var items = {
  "block.minecraft.acacia_button": "Buton de salcâm",
  "block.minecraft.acacia_door": "Ușă de salcâm",
  "block.minecraft.acacia_fence": "Gard de salcâm",
  "block.minecraft.acacia_fence_gate": "Portiță de salcâm",
  "block.minecraft.acacia_hanging_sign": "Semn agățat de salcâm",
  "block.minecraft.acacia_leaves": "Frunze de salcâm",
  "block.minecraft.acacia_log": "Buștean de salcâm",
  "block.minecraft.acacia_planks": "Scânduri de salcâm",
  "block.minecraft.acacia_pressure_plate": "Placă de presiune de salcâm",
  "block.minecraft.acacia_sapling": "Puiet de salcâm",
  "block.minecraft.acacia_shelf": "Raft de salcâm",
  "block.minecraft.acacia_sign": "Semn de salcâm",
  "block.minecraft.acacia_slab": "Lespede de salcâm",
  "block.minecraft.acacia_stairs": "Trepte de salcâm",
  "block.minecraft.acacia_trapdoor": "Trapă de salcâm",
  "block.minecraft.acacia_wall_hanging_sign": "Semn agățat de salcâm pe perete",
  "block.minecraft.acacia_wall_sign": "Semn de salcâm pe perete",
  "block.minecraft.acacia_wood": "Lemn de salcâm",
  "block.minecraft.activator_rail": "Șine activatoare",
  "block.minecraft.air": "Aer",
  "block.minecraft.allium": "Arpagic",
  "block.minecraft.amethyst_block": "Bloc de ametist",
  "block.minecraft.amethyst_cluster": "Mănunchi de ametist",
  "block.minecraft.ancient_debris": "Relicvă antică",
  "block.minecraft.andesite": "Andezit",
  "block.minecraft.andesite_slab": "Lespede de andezit",
  "block.minecraft.andesite_stairs": "Trepte de andezit",
  "block.minecraft.andesite_wall": "Zid de andezit",
  "block.minecraft.anvil": "Nicovală",
  "block.minecraft.attached_melon_stem": "Tulpină de pepene atașată",
  "block.minecraft.attached_pumpkin_stem": "Tulpină de dovleac atașată",
  "block.minecraft.azalea": "Azalee",
  "block.minecraft.azalea_leaves": "Frunze de azalee",
  "block.minecraft.azure_bluet": "Lăptișor",
  "block.minecraft.bamboo": "Bambus",
  "block.minecraft.bamboo_block": "Bloc de bambus",
  "block.minecraft.bamboo_button": "Buton de bambus",
  "block.minecraft.bamboo_door": "Ușă de bambus",
  "block.minecraft.bamboo_fence": "Gard de bambus",
  "block.minecraft.bamboo_fence_gate": "Portiță de bambus",
  "block.minecraft.bamboo_hanging_sign": "Semn agățat de bambus",
  "block.minecraft.bamboo_mosaic": "Mozaic de bambus",
  "block.minecraft.bamboo_mosaic_slab": "Lespede de mozaic de bambus",
  "block.minecraft.bamboo_mosaic_stairs": "Trepte de mozaic de bambus",
  "block.minecraft.bamboo_planks": "Scânduri de bambus",
  "block.minecraft.bamboo_pressure_plate": "Placă de presiune de bambus",
  "block.minecraft.bamboo_sapling": "Lăstar de bambus",
  "block.minecraft.bamboo_shelf": "Raft de bambus",
  "block.minecraft.bamboo_sign": "Semn de bambus",
  "block.minecraft.bamboo_slab": "Lespede de bambus",
  "block.minecraft.bamboo_stairs": "Trepte de bambus",
  "block.minecraft.bamboo_trapdoor": "Trapă de bambus",
  "block.minecraft.bamboo_wall_hanging_sign": "Semn agățat de bambus pe perete",
  "block.minecraft.bamboo_wall_sign": "Semn de bambus pe perete",
  "block.minecraft.banner.base.black": "Câmp negru",
  "block.minecraft.banner.base.blue": "Câmp albastru",
  "block.minecraft.banner.base.brown": "Câmp maro",
  "block.minecraft.banner.base.cyan": "Câmp turcoaz",
  "block.minecraft.banner.base.gray": "Câmp gri",
  "block.minecraft.banner.base.green": "Câmp verde",
  "block.minecraft.banner.base.light_blue": "Câmp bleu",
  "block.minecraft.banner.base.light_gray": "Câmp gri-deschis",
  "block.minecraft.banner.base.lime": "Câmp verde-deschis",
  "block.minecraft.banner.base.magenta": "Câmp magenta",
  "block.minecraft.banner.base.orange": "Câmp portocaliu",
  "block.minecraft.banner.base.pink": "Câmp roz",
  "block.minecraft.banner.base.purple": "Câmp violet",
  "block.minecraft.banner.base.red": "Câmp roșu",
  "block.minecraft.banner.base.white": "Câmp alb",
  "block.minecraft.banner.base.yellow": "Câmp galben",
  "block.minecraft.banner.border.black": "Bordură neagră",
  "block.minecraft.banner.border.blue": "Bordură albastră",
  "block.minecraft.banner.border.brown": "Bordură maro",
  "block.minecraft.banner.border.cyan": "Bordură turcoaz",
  "block.minecraft.banner.border.gray": "Bordură gri",
  "block.minecraft.banner.border.green": "Bordură verde",
  "block.minecraft.banner.border.light_blue": "Bordură bleu",
  "block.minecraft.banner.border.light_gray": "Bordură gri-deschis",
  "block.minecraft.banner.border.lime": "Bordură verde-deschis",
  "block.minecraft.banner.border.magenta": "Bordură magenta",
  "block.minecraft.banner.border.orange": "Bordură portocalie",
  "block.minecraft.banner.border.pink": "Bordură roz",
  "block.minecraft.banner.border.purple": "Bordură violetă",
  "block.minecraft.banner.border.red": "Bordură roșie",
  "block.minecraft.banner.border.white": "Bordură albă",
  "block.minecraft.banner.border.yellow": "Bordură galbenă",
  "block.minecraft.banner.bricks.black": "Câmp zidit negru",
  "block.minecraft.banner.bricks.blue": "Câmp zidit albastru",
  "block.minecraft.banner.bricks.brown": "Câmp zidit maro",
  "block.minecraft.banner.bricks.cyan": "Câmp zidit turcoaz",
  "block.minecraft.banner.bricks.gray": "Câmp zidit gri",
  "block.minecraft.banner.bricks.green": "Câmp zidit verde",
  "block.minecraft.banner.bricks.light_blue": "Câmp zidit bleu",
  "block.minecraft.banner.bricks.light_gray": "Câmp zidit gri-deschis",
  "block.minecraft.banner.bricks.lime": "Câmp zidit verde-deschis",
  "block.minecraft.banner.bricks.magenta": "Câmp zidit magenta",
  "block.minecraft.banner.bricks.orange": "Câmp zidit portocaliu",
  "block.minecraft.banner.bricks.pink": "Câmp zidit roz",
  "block.minecraft.banner.bricks.purple": "Câmp zidit violet",
  "block.minecraft.banner.bricks.red": "Câmp zidit roșu",
  "block.minecraft.banner.bricks.white": "Câmp zidit alb",
  "block.minecraft.banner.bricks.yellow": "Câmp zidit galben",
  "block.minecraft.banner.circle.black": "Disc negru",
  "block.minecraft.banner.circle.blue": "Disc albastru",
  "block.minecraft.banner.circle.brown": "Disc maro",
  "block.minecraft.banner.circle.cyan": "Disc turcoaz",
  "block.minecraft.banner.circle.gray": "Disc gri",
  "block.minecraft.banner.circle.green": "Disc verde",
  "block.minecraft.banner.circle.light_blue": "Disc bleu",
  "block.minecraft.banner.circle.light_gray": "Disc gri-deschis",
  "block.minecraft.banner.circle.lime": "Disc verde-deschis",
  "block.minecraft.banner.circle.magenta": "Disc magenta",
  "block.minecraft.banner.circle.orange": "Disc portocaliu",
  "block.minecraft.banner.circle.pink": "Disc roz",
  "block.minecraft.banner.circle.purple": "Disc violet",
  "block.minecraft.banner.circle.red": "Disc roșu",
  "block.minecraft.banner.circle.white": "Disc alb",
  "block.minecraft.banner.circle.yellow": "Disc galben",
  "block.minecraft.banner.creeper.black": "Creeper negru",
  "block.minecraft.banner.creeper.blue": "Creeper albastru",
  "block.minecraft.banner.creeper.brown": "Creeper maro",
  "block.minecraft.banner.creeper.cyan": "Creeper turcoaz",
  "block.minecraft.banner.creeper.gray": "Creeper gri",
  "block.minecraft.banner.creeper.green": "Creeper verde",
  "block.minecraft.banner.creeper.light_blue": "Creeper bleu",
  "block.minecraft.banner.creeper.light_gray": "Creeper gri-deschis",
  "block.minecraft.banner.creeper.lime": "Creeper verde-deschis",
  "block.minecraft.banner.creeper.magenta": "Creeper magenta",
  "block.minecraft.banner.creeper.orange": "Creeper portocaliu",
  "block.minecraft.banner.creeper.pink": "Creeper roz",
  "block.minecraft.banner.creeper.purple": "Creeper violet",
  "block.minecraft.banner.creeper.red": "Creeper roșu",
  "block.minecraft.banner.creeper.white": "Creeper alb",
  "block.minecraft.banner.creeper.yellow": "Creeper galben",
  "block.minecraft.banner.cross.black": "Cruce diagonală neagră",
  "block.minecraft.banner.cross.blue": "Cruce diagonală albastră",
  "block.minecraft.banner.cross.brown": "Cruce diagonală maro",
  "block.minecraft.banner.cross.cyan": "Cruce diagonală turcoaz",
  "block.minecraft.banner.cross.gray": "Cruce diagonală gri",
  "block.minecraft.banner.cross.green": "Cruce diagonală verde",
  "block.minecraft.banner.cross.light_blue": "Cruce diagonală bleu",
  "block.minecraft.banner.cross.light_gray": "Cruce diagonală gri-deschis",
  "block.minecraft.banner.cross.lime": "Cruce diagonală verde-deschis",
  "block.minecraft.banner.cross.magenta": "Cruce diagonală magenta",
  "block.minecraft.banner.cross.orange": "Cruce diagonală portocalie",
  "block.minecraft.banner.cross.pink": "Cruce diagonală roz",
  "block.minecraft.banner.cross.purple": "Cruce diagonală violetă",
  "block.minecraft.banner.cross.red": "Cruce diagonală roșie",
  "block.minecraft.banner.cross.white": "Cruce diagonală albă",
  "block.minecraft.banner.cross.yellow": "Cruce diagonală galbenă",
  "block.minecraft.banner.curly_border.black": "Bordură dințată neagră",
  "block.minecraft.banner.curly_border.blue": "Bordură dințată albastră",
  "block.minecraft.banner.curly_border.brown": "Bordură dințată maro",
  "block.minecraft.banner.curly_border.cyan": "Bordură dințată turcoaz",
  "block.minecraft.banner.curly_border.gray": "Bordură dințată gri",
  "block.minecraft.banner.curly_border.green": "Bordură dințată verde",
  "block.minecraft.banner.curly_border.light_blue": "Bordură dințată bleu",
  "block.minecraft.banner.curly_border.light_gray": "Bordură dințată gri-deschis",
  "block.minecraft.banner.curly_border.lime": "Bordură dințată verde-deschis",
  "block.minecraft.banner.curly_border.magenta": "Bordură dințată magenta",
  "block.minecraft.banner.curly_border.orange": "Bordură dințată portocalie",
  "block.minecraft.banner.curly_border.pink": "Bordură dințată roz",
  "block.minecraft.banner.curly_border.purple": "Bordură dințată violetă",
  "block.minecraft.banner.curly_border.red": "Bordură dințată roșie",
  "block.minecraft.banner.curly_border.white": "Bordură dințată albă",
  "block.minecraft.banner.curly_border.yellow": "Bordură dințată galbenă",
  "block.minecraft.banner.diagonal_left.black": "Despărțit negru",
  "block.minecraft.banner.diagonal_left.blue": "Despărțit albastru",
  "block.minecraft.banner.diagonal_left.brown": "Despărțit maro",
  "block.minecraft.banner.diagonal_left.cyan": "Despărțit turcoaz",
  "block.minecraft.banner.diagonal_left.gray": "Despărțit gri",
  "block.minecraft.banner.diagonal_left.green": "Despărțit verde",
  "block.minecraft.banner.diagonal_left.light_blue": "Despărțit bleu",
  "block.minecraft.banner.diagonal_left.light_gray": "Despărțit gri-deschis",
  "block.minecraft.banner.diagonal_left.lime": "Despărțit verde-deschis",
  "block.minecraft.banner.diagonal_left.magenta": "Despărțit magenta",
  "block.minecraft.banner.diagonal_left.orange": "Despărțit portocaliu",
  "block.minecraft.banner.diagonal_left.pink": "Despărțit roz",
  "block.minecraft.banner.diagonal_left.purple": "Despărțit violet",
  "block.minecraft.banner.diagonal_left.red": "Despărțit roșu",
  "block.minecraft.banner.diagonal_left.white": "Despărțit alb",
  "block.minecraft.banner.diagonal_left.yellow": "Despărțit galben",
  "block.minecraft.banner.diagonal_right.black": "Spintecat negru",
  "block.minecraft.banner.diagonal_right.blue": "Spintecat albastru",
  "block.minecraft.banner.diagonal_right.brown": "Spintecat maro",
  "block.minecraft.banner.diagonal_right.cyan": "Spintecat turcoaz",
  "block.minecraft.banner.diagonal_right.gray": "Spintecat gri",
  "block.minecraft.banner.diagonal_right.green": "Spintecat verde",
  "block.minecraft.banner.diagonal_right.light_blue": "Spintecat bleu",
  "block.minecraft.banner.diagonal_right.light_gray": "Spintecat gri-deschis",
  "block.minecraft.banner.diagonal_right.lime": "Spintecat verde-deschis",
  "block.minecraft.banner.diagonal_right.magenta": "Spintecat magenta",
  "block.minecraft.banner.diagonal_right.orange": "Spintecat portocaliu",
  "block.minecraft.banner.diagonal_right.pink": "Spintecat roz",
  "block.minecraft.banner.diagonal_right.purple": "Spintecat violet",
  "block.minecraft.banner.diagonal_right.red": "Spintecat roșu",
  "block.minecraft.banner.diagonal_right.white": "Spintecat alb",
  "block.minecraft.banner.diagonal_right.yellow": "Spintecat galben",
  "block.minecraft.banner.diagonal_up_left.black": "Spintecat negru răsturnat",
  "block.minecraft.banner.diagonal_up_left.blue": "Spintecat albastru răsturnat",
  "block.minecraft.banner.diagonal_up_left.brown": "Spintecat maro răsturnat",
  "block.minecraft.banner.diagonal_up_left.cyan": "Spintecat turcoaz răsturnat",
  "block.minecraft.banner.diagonal_up_left.gray": "Spintecat gri răsturnat",
  "block.minecraft.banner.diagonal_up_left.green": "Spintecat verde răsturnat",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Spintecat bleu răsturnat",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Spintecat gri-deschis răsturnat",
  "block.minecraft.banner.diagonal_up_left.lime": "Spintecat verde-deschis răsturnat",
  "block.minecraft.banner.diagonal_up_left.magenta": "Spintecat magenta răsturnat",
  "block.minecraft.banner.diagonal_up_left.orange": "Spintecat portocaliu răsturnat",
  "block.minecraft.banner.diagonal_up_left.pink": "Spintecat roz răsturnat",
  "block.minecraft.banner.diagonal_up_left.purple": "Spintecat violet răsturnat",
  "block.minecraft.banner.diagonal_up_left.red": "Spintecat roșu răsturnat",
  "block.minecraft.banner.diagonal_up_left.white": "Spintecat alb răsturnat",
  "block.minecraft.banner.diagonal_up_left.yellow": "Spintecat galben răsturnat",
  "block.minecraft.banner.diagonal_up_right.black": "Despărțit negru răsturnat",
  "block.minecraft.banner.diagonal_up_right.blue": "Despărțit albastru răsturnat",
  "block.minecraft.banner.diagonal_up_right.brown": "Despărțit maro răsturnat",
  "block.minecraft.banner.diagonal_up_right.cyan": "Despărțit turcoaz răsturnat",
  "block.minecraft.banner.diagonal_up_right.gray": "Despărțit gri răsturnat",
  "block.minecraft.banner.diagonal_up_right.green": "Despărțit verde răsturnat",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Despărțit bleu răsturnat",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Despărțit gri-deschis răsturnat",
  "block.minecraft.banner.diagonal_up_right.lime": "Despărțit verde-deschis răsturnat",
  "block.minecraft.banner.diagonal_up_right.magenta": "Despărțit magenta răsturnat",
  "block.minecraft.banner.diagonal_up_right.orange": "Despărțit portocaliu răsturnat",
  "block.minecraft.banner.diagonal_up_right.pink": "Despărțit roz răsturnat",
  "block.minecraft.banner.diagonal_up_right.purple": "Despărțit violet răsturnat",
  "block.minecraft.banner.diagonal_up_right.red": "Despărțit roșu răsturnat",
  "block.minecraft.banner.diagonal_up_right.white": "Despărțit alb răsturnat",
  "block.minecraft.banner.diagonal_up_right.yellow": "Despărțit galben răsturnat",
  "block.minecraft.banner.flow.black": "Spirală neagră",
  "block.minecraft.banner.flow.blue": "Spirală albastră",
  "block.minecraft.banner.flow.brown": "Spirală maro",
  "block.minecraft.banner.flow.cyan": "Spirală turcoază",
  "block.minecraft.banner.flow.gray": "Spirală gri",
  "block.minecraft.banner.flow.green": "Spirală verde",
  "block.minecraft.banner.flow.light_blue": "Spirală bleu",
  "block.minecraft.banner.flow.light_gray": "Spirală gri-deschis",
  "block.minecraft.banner.flow.lime": "Spirală verde-deschis",
  "block.minecraft.banner.flow.magenta": "Spirală magenta",
  "block.minecraft.banner.flow.orange": "Spirală portocalie",
  "block.minecraft.banner.flow.pink": "Spirală roz",
  "block.minecraft.banner.flow.purple": "Spirală violetă",
  "block.minecraft.banner.flow.red": "Spirală roșie",
  "block.minecraft.banner.flow.white": "Spirală albă",
  "block.minecraft.banner.flow.yellow": "Spirală galbenă",
  "block.minecraft.banner.flower.black": "Floare neagră",
  "block.minecraft.banner.flower.blue": "Floare albastră",
  "block.minecraft.banner.flower.brown": "Floare maro",
  "block.minecraft.banner.flower.cyan": "Floare turcoaz",
  "block.minecraft.banner.flower.gray": "Floare gri",
  "block.minecraft.banner.flower.green": "Floare verde",
  "block.minecraft.banner.flower.light_blue": "Floare bleu",
  "block.minecraft.banner.flower.light_gray": "Floare gri-deschis",
  "block.minecraft.banner.flower.lime": "Floare verde-deschis",
  "block.minecraft.banner.flower.magenta": "Floare magenta",
  "block.minecraft.banner.flower.orange": "Floare portocalie",
  "block.minecraft.banner.flower.pink": "Floare roz",
  "block.minecraft.banner.flower.purple": "Floare violetă",
  "block.minecraft.banner.flower.red": "Floare roșie",
  "block.minecraft.banner.flower.white": "Floare albă",
  "block.minecraft.banner.flower.yellow": "Floare galbenă",
  "block.minecraft.banner.globe.black": "Glob negru",
  "block.minecraft.banner.globe.blue": "Glob albastru",
  "block.minecraft.banner.globe.brown": "Glob maro",
  "block.minecraft.banner.globe.cyan": "Glob turcoaz",
  "block.minecraft.banner.globe.gray": "Glob gri",
  "block.minecraft.banner.globe.green": "Glob verde",
  "block.minecraft.banner.globe.light_blue": "Glob bleu",
  "block.minecraft.banner.globe.light_gray": "Glob gri-deschis",
  "block.minecraft.banner.globe.lime": "Glob verde-deschis",
  "block.minecraft.banner.globe.magenta": "Glob magenta",
  "block.minecraft.banner.globe.orange": "Glob portocaliu",
  "block.minecraft.banner.globe.pink": "Glob roz",
  "block.minecraft.banner.globe.purple": "Glob violet",
  "block.minecraft.banner.globe.red": "Glob roșu",
  "block.minecraft.banner.globe.white": "Glob alb",
  "block.minecraft.banner.globe.yellow": "Glob galben",
  "block.minecraft.banner.gradient.black": "Degrade negru",
  "block.minecraft.banner.gradient.blue": "Degrade albastru",
  "block.minecraft.banner.gradient.brown": "Degrade maro",
  "block.minecraft.banner.gradient.cyan": "Degrade turcoaz",
  "block.minecraft.banner.gradient.gray": "Degrade gri",
  "block.minecraft.banner.gradient.green": "Degrade verde",
  "block.minecraft.banner.gradient.light_blue": "Degrade bleu",
  "block.minecraft.banner.gradient.light_gray": "Degrade gri-deschis",
  "block.minecraft.banner.gradient.lime": "Degrade verde-deschis",
  "block.minecraft.banner.gradient.magenta": "Degrade magenta",
  "block.minecraft.banner.gradient.orange": "Degrade portocaliu",
  "block.minecraft.banner.gradient.pink": "Degrade roz",
  "block.minecraft.banner.gradient.purple": "Degrade violet",
  "block.minecraft.banner.gradient.red": "Degrade roșu",
  "block.minecraft.banner.gradient.white": "Degrade alb",
  "block.minecraft.banner.gradient.yellow": "Degrade galben",
  "block.minecraft.banner.gradient_up.black": "Degrade negru în talpă",
  "block.minecraft.banner.gradient_up.blue": "Degrade albastru în talpă",
  "block.minecraft.banner.gradient_up.brown": "Degrade maro în talpă",
  "block.minecraft.banner.gradient_up.cyan": "Degrade turcoaz în talpă",
  "block.minecraft.banner.gradient_up.gray": "Degrade gri în talpă",
  "block.minecraft.banner.gradient_up.green": "Degrade verde în talpă",
  "block.minecraft.banner.gradient_up.light_blue": "Degrade bleu în talpă",
  "block.minecraft.banner.gradient_up.light_gray": "Degrade gri-deschis în talpă",
  "block.minecraft.banner.gradient_up.lime": "Degrade verde-deschis în talpă",
  "block.minecraft.banner.gradient_up.magenta": "Degrade magenta în talpă",
  "block.minecraft.banner.gradient_up.orange": "Degrade portocaliu în talpă",
  "block.minecraft.banner.gradient_up.pink": "Degrade roz în talpă",
  "block.minecraft.banner.gradient_up.purple": "Degrade violet în talpă",
  "block.minecraft.banner.gradient_up.red": "Degrade roșu în talpă",
  "block.minecraft.banner.gradient_up.white": "Degrade alb în talpă",
  "block.minecraft.banner.gradient_up.yellow": "Degrade galben în talpă",
  "block.minecraft.banner.guster.black": "Rafală neagră",
  "block.minecraft.banner.guster.blue": "Rafală albastră",
  "block.minecraft.banner.guster.brown": "Rafală maro",
  "block.minecraft.banner.guster.cyan": "Rafală turcoaz",
  "block.minecraft.banner.guster.gray": "Rafală gri",
  "block.minecraft.banner.guster.green": "Rafală verde",
  "block.minecraft.banner.guster.light_blue": "Rafală bleu",
  "block.minecraft.banner.guster.light_gray": "Rafală gri-deschis",
  "block.minecraft.banner.guster.lime": "Rafală verde-deschis",
  "block.minecraft.banner.guster.magenta": "Rafală magenta",
  "block.minecraft.banner.guster.orange": "Rafală portocalie",
  "block.minecraft.banner.guster.pink": "Rafală roz",
  "block.minecraft.banner.guster.purple": "Rafală mov",
  "block.minecraft.banner.guster.red": "Rafală roșie",
  "block.minecraft.banner.guster.white": "Rafală albă",
  "block.minecraft.banner.guster.yellow": "Rafală galbenă",
  "block.minecraft.banner.half_horizontal.black": "Tăiat negru",
  "block.minecraft.banner.half_horizontal.blue": "Tăiat albastru",
  "block.minecraft.banner.half_horizontal.brown": "Tăiat maro",
  "block.minecraft.banner.half_horizontal.cyan": "Tăiat turcoaz",
  "block.minecraft.banner.half_horizontal.gray": "Tăiat gri",
  "block.minecraft.banner.half_horizontal.green": "Tăiat verde",
  "block.minecraft.banner.half_horizontal.light_blue": "Tăiat bleu",
  "block.minecraft.banner.half_horizontal.light_gray": "Tăiat gri-deschis",
  "block.minecraft.banner.half_horizontal.lime": "Tăiat verde-deschis",
  "block.minecraft.banner.half_horizontal.magenta": "Tăiat magenta",
  "block.minecraft.banner.half_horizontal.orange": "Tăiat portocaliu",
  "block.minecraft.banner.half_horizontal.pink": "Tăiat roz",
  "block.minecraft.banner.half_horizontal.purple": "Tăiat violet",
  "block.minecraft.banner.half_horizontal.red": "Tăiat roșu",
  "block.minecraft.banner.half_horizontal.white": "Tăiat alb",
  "block.minecraft.banner.half_horizontal.yellow": "Tăiat galben",
  "block.minecraft.banner.half_horizontal_bottom.black": "Tăiat negru răsturnat",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Tăiat albastru răsturnat",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Tăiat maro răsturnat",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Tăiat turcoaz răsturnat",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Tăiat gri răsturnat",
  "block.minecraft.banner.half_horizontal_bottom.green": "Tăiat verde răsturnat",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Tăiat bleu răsturnat",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Tăiat gri-deschis răsturnat",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Tăiat verde-deschis răsturnat",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Tăiat magenta răsturnat",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Tăiat portocaliu răsturnat",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Tăiat roz răsturnat",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Tăiat violet răsturnat",
  "block.minecraft.banner.half_horizontal_bottom.red": "Tăiat roșu răsturnat",
  "block.minecraft.banner.half_horizontal_bottom.white": "Tăiat alb răsturnat",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Tăiat galben răsturnat",
  "block.minecraft.banner.half_vertical.black": "Despicat negru",
  "block.minecraft.banner.half_vertical.blue": "Despicat albastru",
  "block.minecraft.banner.half_vertical.brown": "Despicat maro",
  "block.minecraft.banner.half_vertical.cyan": "Despicat turcoaz",
  "block.minecraft.banner.half_vertical.gray": "Despicat gri",
  "block.minecraft.banner.half_vertical.green": "Despicat verde",
  "block.minecraft.banner.half_vertical.light_blue": "Despicat bleu",
  "block.minecraft.banner.half_vertical.light_gray": "Despicat gri-deschis",
  "block.minecraft.banner.half_vertical.lime": "Despicat verde-deschis",
  "block.minecraft.banner.half_vertical.magenta": "Despicat magenta",
  "block.minecraft.banner.half_vertical.orange": "Despicat portocaliu",
  "block.minecraft.banner.half_vertical.pink": "Despicat roz",
  "block.minecraft.banner.half_vertical.purple": "Despicat violet",
  "block.minecraft.banner.half_vertical.red": "Despicat roșu",
  "block.minecraft.banner.half_vertical.white": "Despicat alb",
  "block.minecraft.banner.half_vertical.yellow": "Despicat galben",
  "block.minecraft.banner.half_vertical_right.black": "Despicat negru răsturnat",
  "block.minecraft.banner.half_vertical_right.blue": "Despicat albastru răsturnat",
  "block.minecraft.banner.half_vertical_right.brown": "Despicat maro răsturnat",
  "block.minecraft.banner.half_vertical_right.cyan": "Despicat turcoaz răsturnat",
  "block.minecraft.banner.half_vertical_right.gray": "Despicat gri răsturnat",
  "block.minecraft.banner.half_vertical_right.green": "Despicat verde răsturnat",
  "block.minecraft.banner.half_vertical_right.light_blue": "Despicat bleu răsturnat",
  "block.minecraft.banner.half_vertical_right.light_gray": "Despicat gri-deschis răsturnat",
  "block.minecraft.banner.half_vertical_right.lime": "Despicat verde-deschis răsturnat",
  "block.minecraft.banner.half_vertical_right.magenta": "Despicat magenta răsturnat",
  "block.minecraft.banner.half_vertical_right.orange": "Despicat portocaliu răsturnat",
  "block.minecraft.banner.half_vertical_right.pink": "Despicat roz răsturnat",
  "block.minecraft.banner.half_vertical_right.purple": "Despicat violet răsturnat",
  "block.minecraft.banner.half_vertical_right.red": "Despicat roșu răsturnat",
  "block.minecraft.banner.half_vertical_right.white": "Despicat alb răsturnat",
  "block.minecraft.banner.half_vertical_right.yellow": "Despicat galben răsturnat",
  "block.minecraft.banner.mojang.black": "Chestie neagră",
  "block.minecraft.banner.mojang.blue": "Chestie albastră",
  "block.minecraft.banner.mojang.brown": "Chestie maro",
  "block.minecraft.banner.mojang.cyan": "Chestie turcoaz",
  "block.minecraft.banner.mojang.gray": "Chestie gri",
  "block.minecraft.banner.mojang.green": "Chestie verde",
  "block.minecraft.banner.mojang.light_blue": "Chestie bleu",
  "block.minecraft.banner.mojang.light_gray": "Chestie gri-deschis",
  "block.minecraft.banner.mojang.lime": "Chestie verde-deschis",
  "block.minecraft.banner.mojang.magenta": "Chestie magenta",
  "block.minecraft.banner.mojang.orange": "Chestie portocalie",
  "block.minecraft.banner.mojang.pink": "Chestie roz",
  "block.minecraft.banner.mojang.purple": "Chestie violetă",
  "block.minecraft.banner.mojang.red": "Chestie roșie",
  "block.minecraft.banner.mojang.white": "Chestie albă",
  "block.minecraft.banner.mojang.yellow": "Chestie galbenă",
  "block.minecraft.banner.piglin.black": "Rât negru",
  "block.minecraft.banner.piglin.blue": "Rât albastru",
  "block.minecraft.banner.piglin.brown": "Rât maro",
  "block.minecraft.banner.piglin.cyan": "Rât turcoaz",
  "block.minecraft.banner.piglin.gray": "Rât gri",
  "block.minecraft.banner.piglin.green": "Rât verde",
  "block.minecraft.banner.piglin.light_blue": "Rât bleu",
  "block.minecraft.banner.piglin.light_gray": "Rât gri-deschis",
  "block.minecraft.banner.piglin.lime": "Rât verde-deschis",
  "block.minecraft.banner.piglin.magenta": "Rât magenta",
  "block.minecraft.banner.piglin.orange": "Rât portocaliu",
  "block.minecraft.banner.piglin.pink": "Rât roz",
  "block.minecraft.banner.piglin.purple": "Rât violet",
  "block.minecraft.banner.piglin.red": "Rât roșu",
  "block.minecraft.banner.piglin.white": "Rât alb",
  "block.minecraft.banner.piglin.yellow": "Rât galben",
  "block.minecraft.banner.rhombus.black": "Romb negru",
  "block.minecraft.banner.rhombus.blue": "Romb albastru",
  "block.minecraft.banner.rhombus.brown": "Romb maro",
  "block.minecraft.banner.rhombus.cyan": "Romb turcoaz",
  "block.minecraft.banner.rhombus.gray": "Romb gri",
  "block.minecraft.banner.rhombus.green": "Romb verde",
  "block.minecraft.banner.rhombus.light_blue": "Romb bleu",
  "block.minecraft.banner.rhombus.light_gray": "Romb gri-deschis",
  "block.minecraft.banner.rhombus.lime": "Romb verde-deschis",
  "block.minecraft.banner.rhombus.magenta": "Romb magenta",
  "block.minecraft.banner.rhombus.orange": "Romb portocaliu",
  "block.minecraft.banner.rhombus.pink": "Romb roz",
  "block.minecraft.banner.rhombus.purple": "Romb violet",
  "block.minecraft.banner.rhombus.red": "Romb roșu",
  "block.minecraft.banner.rhombus.white": "Romb alb",
  "block.minecraft.banner.rhombus.yellow": "Romb galben",
  "block.minecraft.banner.skull.black": "Cap de mort negru",
  "block.minecraft.banner.skull.blue": "Cap de mort albastru",
  "block.minecraft.banner.skull.brown": "Cap de mort maro",
  "block.minecraft.banner.skull.cyan": "Cap de mort turcoaz",
  "block.minecraft.banner.skull.gray": "Cap de mort gri",
  "block.minecraft.banner.skull.green": "Cap de mort verde",
  "block.minecraft.banner.skull.light_blue": "Cap de mort bleu",
  "block.minecraft.banner.skull.light_gray": "Cap de mort gri-deschis",
  "block.minecraft.banner.skull.lime": "Cap de mort verde-deschis",
  "block.minecraft.banner.skull.magenta": "Cap de mort magenta",
  "block.minecraft.banner.skull.orange": "Cap de mort portocaliu",
  "block.minecraft.banner.skull.pink": "Cap de mort roz",
  "block.minecraft.banner.skull.purple": "Cap de mort violet",
  "block.minecraft.banner.skull.red": "Cap de mort roșu",
  "block.minecraft.banner.skull.white": "Cap de mort alb",
  "block.minecraft.banner.skull.yellow": "Cap de mort galben",
  "block.minecraft.banner.small_stripes.black": "Paluri negre",
  "block.minecraft.banner.small_stripes.blue": "Paluri albastre",
  "block.minecraft.banner.small_stripes.brown": "Paluri maro",
  "block.minecraft.banner.small_stripes.cyan": "Paluri turcoaz",
  "block.minecraft.banner.small_stripes.gray": "Paluri gri",
  "block.minecraft.banner.small_stripes.green": "Paluri verzi",
  "block.minecraft.banner.small_stripes.light_blue": "Paluri bleu",
  "block.minecraft.banner.small_stripes.light_gray": "Paluri gri-deschis",
  "block.minecraft.banner.small_stripes.lime": "Paluri verzi-deschis",
  "block.minecraft.banner.small_stripes.magenta": "Paluri magenta",
  "block.minecraft.banner.small_stripes.orange": "Paluri portocalii",
  "block.minecraft.banner.small_stripes.pink": "Paluri roz",
  "block.minecraft.banner.small_stripes.purple": "Paluri violete",
  "block.minecraft.banner.small_stripes.red": "Paluri roșii",
  "block.minecraft.banner.small_stripes.white": "Paluri albe",
  "block.minecraft.banner.small_stripes.yellow": "Paluri galbene",
  "block.minecraft.banner.square_bottom_left.black": "Canton negru dextru în talpă",
  "block.minecraft.banner.square_bottom_left.blue": "Canton albastru dextru în talpă",
  "block.minecraft.banner.square_bottom_left.brown": "Canton maro dextru în talpă",
  "block.minecraft.banner.square_bottom_left.cyan": "Canton turcoaz dextru în talpă",
  "block.minecraft.banner.square_bottom_left.gray": "Canton gri dextru în talpă",
  "block.minecraft.banner.square_bottom_left.green": "Canton verde dextru în talpă",
  "block.minecraft.banner.square_bottom_left.light_blue": "Canton bleu dextru în talpă",
  "block.minecraft.banner.square_bottom_left.light_gray": "Canton gri-deschis dextru în talpă",
  "block.minecraft.banner.square_bottom_left.lime": "Canton verde-deschis dextru în talpă",
  "block.minecraft.banner.square_bottom_left.magenta": "Canton magenta dextru în talpă",
  "block.minecraft.banner.square_bottom_left.orange": "Canton portocaliu dextru în talpă",
  "block.minecraft.banner.square_bottom_left.pink": "Canton roz dextru în talpă",
  "block.minecraft.banner.square_bottom_left.purple": "Canton violet dextru în talpă",
  "block.minecraft.banner.square_bottom_left.red": "Canton roșu dextru în talpă",
  "block.minecraft.banner.square_bottom_left.white": "Canton alb dextru în talpă",
  "block.minecraft.banner.square_bottom_left.yellow": "Canton galben dextru în talpă",
  "block.minecraft.banner.square_bottom_right.black": "Canton negru senestru în talpă",
  "block.minecraft.banner.square_bottom_right.blue": "Canton albastru senestru în talpă",
  "block.minecraft.banner.square_bottom_right.brown": "Canton maro senestru în talpă",
  "block.minecraft.banner.square_bottom_right.cyan": "Canton turcoaz senestru în talpă",
  "block.minecraft.banner.square_bottom_right.gray": "Canton gri senestru în talpă",
  "block.minecraft.banner.square_bottom_right.green": "Canton verde senestru în talpă",
  "block.minecraft.banner.square_bottom_right.light_blue": "Canton bleu senestru în talpă",
  "block.minecraft.banner.square_bottom_right.light_gray": "Canton gri-deschis senestru în talpă",
  "block.minecraft.banner.square_bottom_right.lime": "Canton verde-deschis senestru în talpă",
  "block.minecraft.banner.square_bottom_right.magenta": "Canton magenta senestru în talpă",
  "block.minecraft.banner.square_bottom_right.orange": "Canton portocaliu senestru în talpă",
  "block.minecraft.banner.square_bottom_right.pink": "Canton roz senestru în talpă",
  "block.minecraft.banner.square_bottom_right.purple": "Canton violet senestru în talpă",
  "block.minecraft.banner.square_bottom_right.red": "Canton roșu senestru în talpă",
  "block.minecraft.banner.square_bottom_right.white": "Canton alb senestru în talpă",
  "block.minecraft.banner.square_bottom_right.yellow": "Canton galben senestru în talpă",
  "block.minecraft.banner.square_top_left.black": "Canton negru dextru în șef",
  "block.minecraft.banner.square_top_left.blue": "Canton albastru dextru în șef",
  "block.minecraft.banner.square_top_left.brown": "Canton maro dextru în șef",
  "block.minecraft.banner.square_top_left.cyan": "Canton turcoaz dextru în șef",
  "block.minecraft.banner.square_top_left.gray": "Canton gri dextru în șef",
  "block.minecraft.banner.square_top_left.green": "Canton verde dextru în șef",
  "block.minecraft.banner.square_top_left.light_blue": "Canton bleu dextru în șef",
  "block.minecraft.banner.square_top_left.light_gray": "Canton gri-deschis dextru în șef",
  "block.minecraft.banner.square_top_left.lime": "Canton verde-deschis dextru în șef",
  "block.minecraft.banner.square_top_left.magenta": "Canton magenta dextru în șef",
  "block.minecraft.banner.square_top_left.orange": "Canton portocaliu dextru în șef",
  "block.minecraft.banner.square_top_left.pink": "Canton roz dextru în șef",
  "block.minecraft.banner.square_top_left.purple": "Canton violet dextru în șef",
  "block.minecraft.banner.square_top_left.red": "Canton roșu dextru în șef",
  "block.minecraft.banner.square_top_left.white": "Canton alb dextru în șef",
  "block.minecraft.banner.square_top_left.yellow": "Canton galben dextru în șef",
  "block.minecraft.banner.square_top_right.black": "Canton negru senestru în șef",
  "block.minecraft.banner.square_top_right.blue": "Canton albastru senestru în șef",
  "block.minecraft.banner.square_top_right.brown": "Canton maro senestru în șef",
  "block.minecraft.banner.square_top_right.cyan": "Canton turcoaz senestru în șef",
  "block.minecraft.banner.square_top_right.gray": "Canton gri senestru în șef",
  "block.minecraft.banner.square_top_right.green": "Canton verde senestru în șef",
  "block.minecraft.banner.square_top_right.light_blue": "Canton bleu senestru în șef",
  "block.minecraft.banner.square_top_right.light_gray": "Canton gri-deschis senestru în șef",
  "block.minecraft.banner.square_top_right.lime": "Canton verde-deschis senestru în șef",
  "block.minecraft.banner.square_top_right.magenta": "Canton magenta senestru în șef",
  "block.minecraft.banner.square_top_right.orange": "Canton portocaliu senestru în șef",
  "block.minecraft.banner.square_top_right.pink": "Canton roz senestru în șef",
  "block.minecraft.banner.square_top_right.purple": "Canton violet senestru în șef",
  "block.minecraft.banner.square_top_right.red": "Canton roșu senestru în șef",
  "block.minecraft.banner.square_top_right.white": "Canton alb senestru în șef",
  "block.minecraft.banner.square_top_right.yellow": "Canton galben senestru în șef",
  "block.minecraft.banner.straight_cross.black": "Cruce neagră",
  "block.minecraft.banner.straight_cross.blue": "Cruce albastră",
  "block.minecraft.banner.straight_cross.brown": "Cruce maro",
  "block.minecraft.banner.straight_cross.cyan": "Cruce turcoaz",
  "block.minecraft.banner.straight_cross.gray": "Cruce gri",
  "block.minecraft.banner.straight_cross.green": "Cruce verde",
  "block.minecraft.banner.straight_cross.light_blue": "Cruce bleu",
  "block.minecraft.banner.straight_cross.light_gray": "Cruce gri-deschis",
  "block.minecraft.banner.straight_cross.lime": "Cruce verde-deschis",
  "block.minecraft.banner.straight_cross.magenta": "Cruce magenta",
  "block.minecraft.banner.straight_cross.orange": "Cruce portocalie",
  "block.minecraft.banner.straight_cross.pink": "Cruce roz",
  "block.minecraft.banner.straight_cross.purple": "Cruce violetă",
  "block.minecraft.banner.straight_cross.red": "Cruce roșie",
  "block.minecraft.banner.straight_cross.white": "Cruce albă",
  "block.minecraft.banner.straight_cross.yellow": "Cruce galbenă",
  "block.minecraft.banner.stripe_bottom.black": "Talpă neagră",
  "block.minecraft.banner.stripe_bottom.blue": "Talpă albastră",
  "block.minecraft.banner.stripe_bottom.brown": "Talpă maro",
  "block.minecraft.banner.stripe_bottom.cyan": "Talpă turcoaz",
  "block.minecraft.banner.stripe_bottom.gray": "Talpă gri",
  "block.minecraft.banner.stripe_bottom.green": "Talpă verde",
  "block.minecraft.banner.stripe_bottom.light_blue": "Talpă bleu",
  "block.minecraft.banner.stripe_bottom.light_gray": "Talpă gri-deschis",
  "block.minecraft.banner.stripe_bottom.lime": "Talpă verde-deschis",
  "block.minecraft.banner.stripe_bottom.magenta": "Talpă magenta",
  "block.minecraft.banner.stripe_bottom.orange": "Talpă portocalie",
  "block.minecraft.banner.stripe_bottom.pink": "Talpă roz",
  "block.minecraft.banner.stripe_bottom.purple": "Talpă violetă",
  "block.minecraft.banner.stripe_bottom.red": "Talpă roșie",
  "block.minecraft.banner.stripe_bottom.white": "Talpă albă",
  "block.minecraft.banner.stripe_bottom.yellow": "Talpă galbenă",
  "block.minecraft.banner.stripe_center.black": "Pal negru",
  "block.minecraft.banner.stripe_center.blue": "Pal albastru",
  "block.minecraft.banner.stripe_center.brown": "Pal maro",
  "block.minecraft.banner.stripe_center.cyan": "Pal turcoaz",
  "block.minecraft.banner.stripe_center.gray": "Pal gri",
  "block.minecraft.banner.stripe_center.green": "Pal verde",
  "block.minecraft.banner.stripe_center.light_blue": "Pal bleu",
  "block.minecraft.banner.stripe_center.light_gray": "Pal gri-deschis",
  "block.minecraft.banner.stripe_center.lime": "Pal verde-deschis",
  "block.minecraft.banner.stripe_center.magenta": "Pal magenta",
  "block.minecraft.banner.stripe_center.orange": "Pal portocaliu",
  "block.minecraft.banner.stripe_center.pink": "Pal roz",
  "block.minecraft.banner.stripe_center.purple": "Pal violet",
  "block.minecraft.banner.stripe_center.red": "Pal roșu",
  "block.minecraft.banner.stripe_center.white": "Pal alb",
  "block.minecraft.banner.stripe_center.yellow": "Pal galben",
  "block.minecraft.banner.stripe_downleft.black": "Bară neagră",
  "block.minecraft.banner.stripe_downleft.blue": "Bară albastră",
  "block.minecraft.banner.stripe_downleft.brown": "Bară maro",
  "block.minecraft.banner.stripe_downleft.cyan": "Bară turcoaz",
  "block.minecraft.banner.stripe_downleft.gray": "Bară gri",
  "block.minecraft.banner.stripe_downleft.green": "Bară verde",
  "block.minecraft.banner.stripe_downleft.light_blue": "Bară bleu",
  "block.minecraft.banner.stripe_downleft.light_gray": "Bară gri-deschis",
  "block.minecraft.banner.stripe_downleft.lime": "Bară verde-deschis",
  "block.minecraft.banner.stripe_downleft.magenta": "Bară magenta",
  "block.minecraft.banner.stripe_downleft.orange": "Bară portocalie",
  "block.minecraft.banner.stripe_downleft.pink": "Bară roz",
  "block.minecraft.banner.stripe_downleft.purple": "Bară violetă",
  "block.minecraft.banner.stripe_downleft.red": "Bară roșie",
  "block.minecraft.banner.stripe_downleft.white": "Bară albă",
  "block.minecraft.banner.stripe_downleft.yellow": "Bară galbenă",
  "block.minecraft.banner.stripe_downright.black": "Bandă neagră",
  "block.minecraft.banner.stripe_downright.blue": "Bandă albastră",
  "block.minecraft.banner.stripe_downright.brown": "Bandă maro",
  "block.minecraft.banner.stripe_downright.cyan": "Bandă turcoaz",
  "block.minecraft.banner.stripe_downright.gray": "Bandă gri",
  "block.minecraft.banner.stripe_downright.green": "Bandă verde",
  "block.minecraft.banner.stripe_downright.light_blue": "Bandă bleu",
  "block.minecraft.banner.stripe_downright.light_gray": "Bandă gri-deschis",
  "block.minecraft.banner.stripe_downright.lime": "Bandă verde-deschis",
  "block.minecraft.banner.stripe_downright.magenta": "Bandă magenta",
  "block.minecraft.banner.stripe_downright.orange": "Bandă portocalie",
  "block.minecraft.banner.stripe_downright.pink": "Bandă roz",
  "block.minecraft.banner.stripe_downright.purple": "Bandă violetă",
  "block.minecraft.banner.stripe_downright.red": "Bandă roșie",
  "block.minecraft.banner.stripe_downright.white": "Bandă albă",
  "block.minecraft.banner.stripe_downright.yellow": "Bandă galbenă",
  "block.minecraft.banner.stripe_left.black": "Dungă stângă neagră",
  "block.minecraft.banner.stripe_left.blue": "Dungă stângă albastră",
  "block.minecraft.banner.stripe_left.brown": "Dungă stângă maro",
  "block.minecraft.banner.stripe_left.cyan": "Dungă stângă turcoaz",
  "block.minecraft.banner.stripe_left.gray": "Dungă stângă gri",
  "block.minecraft.banner.stripe_left.green": "Dungă stângă verde",
  "block.minecraft.banner.stripe_left.light_blue": "Dungă stângă bleu",
  "block.minecraft.banner.stripe_left.light_gray": "Dungă stângă gri-deschis",
  "block.minecraft.banner.stripe_left.lime": "Dungă stângă verde-deschis",
  "block.minecraft.banner.stripe_left.magenta": "Dungă stângă magenta",
  "block.minecraft.banner.stripe_left.orange": "Dungă stângă portocalie",
  "block.minecraft.banner.stripe_left.pink": "Dungă stângă roz",
  "block.minecraft.banner.stripe_left.purple": "Dungă stângă violet",
  "block.minecraft.banner.stripe_left.red": "Dungă stângă roșie",
  "block.minecraft.banner.stripe_left.white": "Dungă stângă albă",
  "block.minecraft.banner.stripe_left.yellow": "Dungă stângă galbenă",
  "block.minecraft.banner.stripe_middle.black": "Fascie neagră",
  "block.minecraft.banner.stripe_middle.blue": "Fascie albastră",
  "block.minecraft.banner.stripe_middle.brown": "Fascie maro",
  "block.minecraft.banner.stripe_middle.cyan": "Fascie turcoaz",
  "block.minecraft.banner.stripe_middle.gray": "Fascie gri",
  "block.minecraft.banner.stripe_middle.green": "Fascie verde",
  "block.minecraft.banner.stripe_middle.light_blue": "Fascie bleu",
  "block.minecraft.banner.stripe_middle.light_gray": "Fascie gri-deschis",
  "block.minecraft.banner.stripe_middle.lime": "Fascie verde-deschis",
  "block.minecraft.banner.stripe_middle.magenta": "Fascie magenta",
  "block.minecraft.banner.stripe_middle.orange": "Fascie portocalie",
  "block.minecraft.banner.stripe_middle.pink": "Fascie roz",
  "block.minecraft.banner.stripe_middle.purple": "Fascie violetă",
  "block.minecraft.banner.stripe_middle.red": "Fascie roșie",
  "block.minecraft.banner.stripe_middle.white": "Fascie albă",
  "block.minecraft.banner.stripe_middle.yellow": "Fascie galbenă",
  "block.minecraft.banner.stripe_right.black": "Dungă dreaptă neagră",
  "block.minecraft.banner.stripe_right.blue": "Dungă dreaptă albastră",
  "block.minecraft.banner.stripe_right.brown": "Dungă dreaptă maro",
  "block.minecraft.banner.stripe_right.cyan": "Dungă dreaptă turcoaz",
  "block.minecraft.banner.stripe_right.gray": "Dungă dreaptă gri",
  "block.minecraft.banner.stripe_right.green": "Dungă dreaptă verde",
  "block.minecraft.banner.stripe_right.light_blue": "Dungă dreaptă bleu",
  "block.minecraft.banner.stripe_right.light_gray": "Dungă dreaptă gri-deschis",
  "block.minecraft.banner.stripe_right.lime": "Dungă dreaptă verde-deschis",
  "block.minecraft.banner.stripe_right.magenta": "Dungă dreaptă magenta",
  "block.minecraft.banner.stripe_right.orange": "Dungă dreaptă portocalie",
  "block.minecraft.banner.stripe_right.pink": "Dungă dreaptă roz",
  "block.minecraft.banner.stripe_right.purple": "Dungă dreaptă violet",
  "block.minecraft.banner.stripe_right.red": "Dungă dreaptă roșie",
  "block.minecraft.banner.stripe_right.white": "Dungă dreaptă albă",
  "block.minecraft.banner.stripe_right.yellow": "Dungă dreaptă galbenă",
  "block.minecraft.banner.stripe_top.black": "Șef negru",
  "block.minecraft.banner.stripe_top.blue": "Șef albastru",
  "block.minecraft.banner.stripe_top.brown": "Șef maro",
  "block.minecraft.banner.stripe_top.cyan": "Șef turcoaz",
  "block.minecraft.banner.stripe_top.gray": "Șef gri",
  "block.minecraft.banner.stripe_top.green": "Șef verde",
  "block.minecraft.banner.stripe_top.light_blue": "Șef bleu",
  "block.minecraft.banner.stripe_top.light_gray": "Șef gri-deschis",
  "block.minecraft.banner.stripe_top.lime": "Șef verde-deschis",
  "block.minecraft.banner.stripe_top.magenta": "Șef magenta",
  "block.minecraft.banner.stripe_top.orange": "Șef portocaliu",
  "block.minecraft.banner.stripe_top.pink": "Șef roz",
  "block.minecraft.banner.stripe_top.purple": "Șef violet",
  "block.minecraft.banner.stripe_top.red": "Șef roșu",
  "block.minecraft.banner.stripe_top.white": "Șef alb",
  "block.minecraft.banner.stripe_top.yellow": "Șef galben",
  "block.minecraft.banner.triangle_bottom.black": "Triunghi negru în talpă",
  "block.minecraft.banner.triangle_bottom.blue": "Triunghi albastru în talpă",
  "block.minecraft.banner.triangle_bottom.brown": "Triunghi maro în talpă",
  "block.minecraft.banner.triangle_bottom.cyan": "Triunghi turcoaz în talpă",
  "block.minecraft.banner.triangle_bottom.gray": "Triunghi gri în talpă",
  "block.minecraft.banner.triangle_bottom.green": "Triunghi verde în talpă",
  "block.minecraft.banner.triangle_bottom.light_blue": "Triunghi bleu în talpă",
  "block.minecraft.banner.triangle_bottom.light_gray": "Triunghi gri-deschis în talpă",
  "block.minecraft.banner.triangle_bottom.lime": "Triunghi verde-deschis în talpă",
  "block.minecraft.banner.triangle_bottom.magenta": "Triunghi magenta în talpă",
  "block.minecraft.banner.triangle_bottom.orange": "Triunghi portocaliu în talpă",
  "block.minecraft.banner.triangle_bottom.pink": "Triunghi roz în talpă",
  "block.minecraft.banner.triangle_bottom.purple": "Triunghi violet în talpă",
  "block.minecraft.banner.triangle_bottom.red": "Triunghi roșu în talpă",
  "block.minecraft.banner.triangle_bottom.white": "Triunghi alb în talpă",
  "block.minecraft.banner.triangle_bottom.yellow": "Triunghi galben în talpă",
  "block.minecraft.banner.triangle_top.black": "Triunghi negru în șef",
  "block.minecraft.banner.triangle_top.blue": "Triunghi albastru în șef",
  "block.minecraft.banner.triangle_top.brown": "Triunghi maro în șef",
  "block.minecraft.banner.triangle_top.cyan": "Triunghi turcoaz în șef",
  "block.minecraft.banner.triangle_top.gray": "Triunghi gri în șef",
  "block.minecraft.banner.triangle_top.green": "Triunghi verde în șef",
  "block.minecraft.banner.triangle_top.light_blue": "Triunghi bleu în șef",
  "block.minecraft.banner.triangle_top.light_gray": "Triunghi gri-deschis în șef",
  "block.minecraft.banner.triangle_top.lime": "Triunghi verde-deschis în șef",
  "block.minecraft.banner.triangle_top.magenta": "Triunghi magenta în șef",
  "block.minecraft.banner.triangle_top.orange": "Triunghi portocaliu în șef",
  "block.minecraft.banner.triangle_top.pink": "Triunghi roz în șef",
  "block.minecraft.banner.triangle_top.purple": "Triunghi violet în șef",
  "block.minecraft.banner.triangle_top.red": "Triunghi roșu în șef",
  "block.minecraft.banner.triangle_top.white": "Triunghi alb în șef",
  "block.minecraft.banner.triangle_top.yellow": "Triunghi galben în șef",
  "block.minecraft.banner.triangles_bottom.black": "Talpă dințată neagră",
  "block.minecraft.banner.triangles_bottom.blue": "Talpă dințată albastră",
  "block.minecraft.banner.triangles_bottom.brown": "Talpă dințată maro",
  "block.minecraft.banner.triangles_bottom.cyan": "Talpă dințată turcoaz",
  "block.minecraft.banner.triangles_bottom.gray": "Talpă dințată gri",
  "block.minecraft.banner.triangles_bottom.green": "Talpă dințată verde",
  "block.minecraft.banner.triangles_bottom.light_blue": "Talpă dințată bleu",
  "block.minecraft.banner.triangles_bottom.light_gray": "Talpă dințată gri-deschis",
  "block.minecraft.banner.triangles_bottom.lime": "Talpă dințată verde-deschis",
  "block.minecraft.banner.triangles_bottom.magenta": "Talpă dințată magenta",
  "block.minecraft.banner.triangles_bottom.orange": "Talpă dințată portocalie",
  "block.minecraft.banner.triangles_bottom.pink": "Talpă dințată roz",
  "block.minecraft.banner.triangles_bottom.purple": "Talpă dințată violetă",
  "block.minecraft.banner.triangles_bottom.red": "Talpă dințată roșie",
  "block.minecraft.banner.triangles_bottom.white": "Talpă dințată albă",
  "block.minecraft.banner.triangles_bottom.yellow": "Talpă dințată galbenă",
  "block.minecraft.banner.triangles_top.black": "Șef negru dințat",
  "block.minecraft.banner.triangles_top.blue": "Șef albastru dințat",
  "block.minecraft.banner.triangles_top.brown": "Șef maro dințat",
  "block.minecraft.banner.triangles_top.cyan": "Șef turcoaz dințat",
  "block.minecraft.banner.triangles_top.gray": "Șef gri dințat",
  "block.minecraft.banner.triangles_top.green": "Șef verde dințat",
  "block.minecraft.banner.triangles_top.light_blue": "Șef bleu dințat",
  "block.minecraft.banner.triangles_top.light_gray": "Șef gri-deschis dințat",
  "block.minecraft.banner.triangles_top.lime": "Șef verde-deschis dințat",
  "block.minecraft.banner.triangles_top.magenta": "Șef magenta dințat",
  "block.minecraft.banner.triangles_top.orange": "Șef portocaliu dințat",
  "block.minecraft.banner.triangles_top.pink": "Șef roz dințat",
  "block.minecraft.banner.triangles_top.purple": "Șef violet dințat",
  "block.minecraft.banner.triangles_top.red": "Șef roșu dințat",
  "block.minecraft.banner.triangles_top.white": "Șef alb dințat",
  "block.minecraft.banner.triangles_top.yellow": "Șef galben dințat",
  "block.minecraft.barrel": "Butoi",
  "block.minecraft.barrier": "Barieră",
  "block.minecraft.basalt": "Bazalt",
  "block.minecraft.beacon": "Far",
  "block.minecraft.beacon.primary": "Putere primară",
  "block.minecraft.beacon.secondary": "Putere secundară",
  "block.minecraft.bed.no_sleep": "Poți dormi doar noaptea sau în timpul furtunilor",
  "block.minecraft.bed.not_safe": "Nu te poți odihni acum: sunt monștri în apropiere",
  "block.minecraft.bed.obstructed": "Acest pat este blocat",
  "block.minecraft.bed.occupied": "Acest pat este ocupat",
  "block.minecraft.bed.too_far_away": "Nu te poți odihni acum: patul este prea departe",
  "block.minecraft.bedrock": "Rocă de bază",
  "block.minecraft.bee_nest": "Cuib de albine",
  "block.minecraft.beehive": "Stup de albine",
  "block.minecraft.beetroots": "Sfeclă",
  "block.minecraft.bell": "Clopot",
  "block.minecraft.big_dripleaf": "Frunză picurătoare mare",
  "block.minecraft.big_dripleaf_stem": "Tulpină de frunză picurătoare mare",
  "block.minecraft.birch_button": "Buton de mesteacăn",
  "block.minecraft.birch_door": "Ușă de mesteacăn",
  "block.minecraft.birch_fence": "Gard de mesteacăn",
  "block.minecraft.birch_fence_gate": "Portiță de mesteacăn",
  "block.minecraft.birch_hanging_sign": "Semn agățat de mesteacăn",
  "block.minecraft.birch_leaves": "Frunze de mesteacăn",
  "block.minecraft.birch_log": "Buștean de mesteacăn",
  "block.minecraft.birch_planks": "Scânduri de mesteacăn",
  "block.minecraft.birch_pressure_plate": "Placă de presiune de mesteacăn",
  "block.minecraft.birch_sapling": "Puiet de mesteacăn",
  "block.minecraft.birch_shelf": "Raft de mesteacăn",
  "block.minecraft.birch_sign": "Semn de mesteacăn",
  "block.minecraft.birch_slab": "Lespede de mesteacăn",
  "block.minecraft.birch_stairs": "Trepte de mesteacăn",
  "block.minecraft.birch_trapdoor": "Trapă de mesteacăn",
  "block.minecraft.birch_wall_hanging_sign": "Semn agățat de mesteacăn pe perete",
  "block.minecraft.birch_wall_sign": "Semn de mesteacăn pe perete",
  "block.minecraft.birch_wood": "Lemn de mesteacăn",
  "block.minecraft.black_banner": "Stindard negru",
  "block.minecraft.black_bed": "Pat negru",
  "block.minecraft.black_candle": "Lumânare neagră",
  "block.minecraft.black_candle_cake": "Tort cu lumânare neagră",
  "block.minecraft.black_carpet": "Covor negru",
  "block.minecraft.black_concrete": "Beton negru",
  "block.minecraft.black_concrete_powder": "Beton uscat negru",
  "block.minecraft.black_glazed_terracotta": "Teracotă smălțuită neagră",
  "block.minecraft.black_shulker_box": "Cutie de shulker neagră",
  "block.minecraft.black_stained_glass": "Sticlă neagră",
  "block.minecraft.black_stained_glass_pane": "Geam negru",
  "block.minecraft.black_terracotta": "Teracotă neagră",
  "block.minecraft.black_wool": "Lână neagră",
  "block.minecraft.blackstone": "Piatră neagră",
  "block.minecraft.blackstone_slab": "Lespede de piatră neagră",
  "block.minecraft.blackstone_stairs": "Trepte de piatră neagră",
  "block.minecraft.blackstone_wall": "Zid de piatră neagră",
  "block.minecraft.blast_furnace": "Furnal",
  "block.minecraft.blue_banner": "Stindard albastru",
  "block.minecraft.blue_bed": "Pat albastru",
  "block.minecraft.blue_candle": "Lumânare albastră",
  "block.minecraft.blue_candle_cake": "Tort cu lumânare albastră",
  "block.minecraft.blue_carpet": "Covor albastru",
  "block.minecraft.blue_concrete": "Beton albastru",
  "block.minecraft.blue_concrete_powder": "Beton uscat albastru",
  "block.minecraft.blue_glazed_terracotta": "Teracotă smălțuită albastră",
  "block.minecraft.blue_ice": "Gheață albastră",
  "block.minecraft.blue_orchid": "Orhidee albastră",
  "block.minecraft.blue_shulker_box": "Cutie de shulker albastră",
  "block.minecraft.blue_stained_glass": "Sticlă albastră",
  "block.minecraft.blue_stained_glass_pane": "Geam albastru",
  "block.minecraft.blue_terracotta": "Teracotă albastră",
  "block.minecraft.blue_wool": "Lână albastră",
  "block.minecraft.bone_block": "Bloc de oase",
  "block.minecraft.bookshelf": "Bibliotecă",
  "block.minecraft.brain_coral": "Coral creier",
  "block.minecraft.brain_coral_block": "Bloc de coral creier",
  "block.minecraft.brain_coral_fan": "Gorgonie creier",
  "block.minecraft.brain_coral_wall_fan": "Gorgonie creier pe perete",
  "block.minecraft.brewing_stand": "Alambic",
  "block.minecraft.brick_slab": "Lespede de cărămizi",
  "block.minecraft.brick_stairs": "Trepte de cărămizi",
  "block.minecraft.brick_wall": "Zid de cărămizi",
  "block.minecraft.bricks": "Cărămizi",
  "block.minecraft.brown_banner": "Stindard maro",
  "block.minecraft.brown_bed": "Pat maro",
  "block.minecraft.brown_candle": "Lumânare maro",
  "block.minecraft.brown_candle_cake": "Tort cu lumânare maro",
  "block.minecraft.brown_carpet": "Covor maro",
  "block.minecraft.brown_concrete": "Beton maro",
  "block.minecraft.brown_concrete_powder": "Beton uscat maro",
  "block.minecraft.brown_glazed_terracotta": "Teracotă smălțuită maro",
  "block.minecraft.brown_mushroom": "Ciupercă maro",
  "block.minecraft.brown_mushroom_block": "Bloc de ciupercă maro",
  "block.minecraft.brown_shulker_box": "Cutie de shulker maro",
  "block.minecraft.brown_stained_glass": "Sticlă maro",
  "block.minecraft.brown_stained_glass_pane": "Geam maro",
  "block.minecraft.brown_terracotta": "Teracotă maro",
  "block.minecraft.brown_wool": "Lână maro",
  "block.minecraft.bubble_column": "Coloană de bule",
  "block.minecraft.bubble_coral": "Coral balon",
  "block.minecraft.bubble_coral_block": "Bloc de coral balon",
  "block.minecraft.bubble_coral_fan": "Gorgonie balon",
  "block.minecraft.bubble_coral_wall_fan": "Gorgonie balon pe perete",
  "block.minecraft.budding_amethyst": "Ametist înmugurit",
  "block.minecraft.bush": "Tufiș",
  "block.minecraft.cactus": "Cactus",
  "block.minecraft.cactus_flower": "Floare de cactus",
  "block.minecraft.cake": "Tort",
  "block.minecraft.calcite": "Calcit",
  "block.minecraft.calibrated_sculk_sensor": "Senzor sculk calibrat",
  "block.minecraft.campfire": "Foc de tabără",
  "block.minecraft.candle": "Lumânare",
  "block.minecraft.candle_cake": "Tort cu lumânare",
  "block.minecraft.carrots": "Morcovi",
  "block.minecraft.cartography_table": "Masă de cartografie",
  "block.minecraft.carved_pumpkin": "Dovleac sculptat",
  "block.minecraft.cauldron": "Cazan",
  "block.minecraft.cave_air": "Aer de peșteră",
  "block.minecraft.cave_vines": "Liane de peșteră",
  "block.minecraft.cave_vines_plant": "Planta lianelor de peșteră",
  "block.minecraft.chain": "Lanț",
  "block.minecraft.chain_command_block": "Bloc de comenzi în lanț",
  "block.minecraft.cherry_button": "Buton de cireș",
  "block.minecraft.cherry_door": "Ușă de cireș",
  "block.minecraft.cherry_fence": "Gard de cireș",
  "block.minecraft.cherry_fence_gate": "Portiță de cireș",
  "block.minecraft.cherry_hanging_sign": "Semn agățat de cireș",
  "block.minecraft.cherry_leaves": "Frunze de cireș",
  "block.minecraft.cherry_log": "Buștean de cireș",
  "block.minecraft.cherry_planks": "Scânduri de cireș",
  "block.minecraft.cherry_pressure_plate": "Placă de presiune de cireș",
  "block.minecraft.cherry_sapling": "Puiet de cireș",
  "block.minecraft.cherry_shelf": "Raft de cireș",
  "block.minecraft.cherry_sign": "Semn de cireș",
  "block.minecraft.cherry_slab": "Lespede de cireș",
  "block.minecraft.cherry_stairs": "Trepte de cireș",
  "block.minecraft.cherry_trapdoor": "Trapă de cireș",
  "block.minecraft.cherry_wall_hanging_sign": "Semn agățat de cireș pe perete",
  "block.minecraft.cherry_wall_sign": "Semn de cireș pe perete",
  "block.minecraft.cherry_wood": "Lemn de cireș",
  "block.minecraft.chest": "Cufăr",
  "block.minecraft.chipped_anvil": "Nicovală ciobită",
  "block.minecraft.chiseled_bookshelf": "Bibliotecă cioplită",
  "block.minecraft.chiseled_copper": "Bloc de cupru sculptat",
  "block.minecraft.chiseled_deepslate": "Ardezie sculptată",
  "block.minecraft.chiseled_nether_bricks": "Cărămizi de Nether sculptate",
  "block.minecraft.chiseled_polished_blackstone": "Piatră neagră șlefuită sculptată",
  "block.minecraft.chiseled_quartz_block": "Bloc de cuarț sculptat",
  "block.minecraft.chiseled_red_sandstone": "Gresie roșie sculptată",
  "block.minecraft.chiseled_resin_bricks": "Cărămizi de rășină sculptate",
  "block.minecraft.chiseled_sandstone": "Gresie sculptată",
  "block.minecraft.chiseled_stone_bricks": "Cărămizi de piatră sculptate",
  "block.minecraft.chiseled_tuff": "Tuf sculptat",
  "block.minecraft.chiseled_tuff_bricks": "Cărămizi de tuf sculptat",
  "block.minecraft.chorus_flower": "Floare corală",
  "block.minecraft.chorus_plant": "Plantă corală",
  "block.minecraft.clay": "Lut",
  "block.minecraft.closed_eyeblossom": "Floare-ochi închisă",
  "block.minecraft.coal_block": "Bloc de cărbune",
  "block.minecraft.coal_ore": "Minereu de cărbune",
  "block.minecraft.coarse_dirt": "Pământ pietros",
  "block.minecraft.cobbled_deepslate": "Ardezie adâncă împietrită",
  "block.minecraft.cobbled_deepslate_slab": "Lespede de ardezie adâncă împietrită",
  "block.minecraft.cobbled_deepslate_stairs": "Trepte de ardezie adâncă împietrit",
  "block.minecraft.cobbled_deepslate_wall": "Zid de ardezie adâncă împietrit",
  "block.minecraft.cobblestone": "Pietruială",
  "block.minecraft.cobblestone_slab": "Lespede de pietruială",
  "block.minecraft.cobblestone_stairs": "Trepte de pietruială",
  "block.minecraft.cobblestone_wall": "Zid de pietruială",
  "block.minecraft.cobweb": "Pânză de păianjen",
  "block.minecraft.cocoa": "Cacao",
  "block.minecraft.command_block": "Bloc de comenzi",
  "block.minecraft.comparator": "Comparator de redstone",
  "block.minecraft.composter": "Compostor",
  "block.minecraft.conduit": "Conductă",
  "block.minecraft.copper_bars": "Gratii de cupru",
  "block.minecraft.copper_block": "Bloc de cupru",
  "block.minecraft.copper_bulb": "Bec de cupru",
  "block.minecraft.copper_chain": "Lanț de cupru",
  "block.minecraft.copper_chest": "Cufăr de cupru",
  "block.minecraft.copper_door": "Ușă de cupru",
  "block.minecraft.copper_golem_statue": "Statuie de golem de cupru",
  "block.minecraft.copper_grate": "Grilaj de cupru",
  "block.minecraft.copper_lantern": "Felinar de cupru",
  "block.minecraft.copper_ore": "Minereu de cupru",
  "block.minecraft.copper_torch": "Torță de cupru",
  "block.minecraft.copper_trapdoor": "Trapă de cupru",
  "block.minecraft.copper_wall_torch": "Torță de cupru pe perete",
  "block.minecraft.cornflower": "Albăstrea",
  "block.minecraft.cracked_deepslate_bricks": "Cărămizi de ardezie adâncă crăpate",
  "block.minecraft.cracked_deepslate_tiles": "Plăci de ardezie adâncă crăpate",
  "block.minecraft.cracked_nether_bricks": "Cărămizi de Nether crăpate",
  "block.minecraft.cracked_polished_blackstone_bricks": "Cărămizi de piatră neagră șlefuită crăpate",
  "block.minecraft.cracked_stone_bricks": "Cărămizi de piatră crăpate",
  "block.minecraft.crafter": "Fabricator",
  "block.minecraft.crafting_table": "Masă de lucru",
  "block.minecraft.creaking_heart": "Inimă de scârțâitor",
  "block.minecraft.creeper_head": "Cap de creeper",
  "block.minecraft.creeper_wall_head": "Cap de creeper pe perete",
  "block.minecraft.crimson_button": "Buton stacojiu",
  "block.minecraft.crimson_door": "Ușă stacojie",
  "block.minecraft.crimson_fence": "Gard stacojiu",
  "block.minecraft.crimson_fence_gate": "Portiță stacojie",
  "block.minecraft.crimson_fungus": "Ciupercă stacojie",
  "block.minecraft.crimson_hanging_sign": "Semn agățat stacojiu",
  "block.minecraft.crimson_hyphae": "Hife stacojii",
  "block.minecraft.crimson_nylium": "Niliu stacojiu",
  "block.minecraft.crimson_planks": "Scânduri stacojii",
  "block.minecraft.crimson_pressure_plate": "Placă de presiune stacojie",
  "block.minecraft.crimson_roots": "Rădăcini stacojii",
  "block.minecraft.crimson_shelf": "Raft stacojiu",
  "block.minecraft.crimson_sign": "Semn stacojiu",
  "block.minecraft.crimson_slab": "Lespede stacojie",
  "block.minecraft.crimson_stairs": "Trepte stacojii",
  "block.minecraft.crimson_stem": "Tulpină stacojie",
  "block.minecraft.crimson_trapdoor": "Trapă stacojie",
  "block.minecraft.crimson_wall_hanging_sign": "Semn agățat stacojiu pe perete",
  "block.minecraft.crimson_wall_sign": "Semn stacojiu pe perete",
  "block.minecraft.crying_obsidian": "Obsidian plângător",
  "block.minecraft.cut_copper": "Bloc de cupru tăiat",
  "block.minecraft.cut_copper_slab": "Lespede de cupru tăiată",
  "block.minecraft.cut_copper_stairs": "Trepte de cupru tăiate",
  "block.minecraft.cut_red_sandstone": "Gresie roșie tăiată",
  "block.minecraft.cut_red_sandstone_slab": "Lespede de gresie roșie tăiată",
  "block.minecraft.cut_sandstone": "Gresie tăiată",
  "block.minecraft.cut_sandstone_slab": "Lespede de gresie tăiată",
  "block.minecraft.cyan_banner": "Stindard turcoaz",
  "block.minecraft.cyan_bed": "Pat turcoaz",
  "block.minecraft.cyan_candle": "Lumânare turcoaz",
  "block.minecraft.cyan_candle_cake": "Tort cu lumânare turcoaz",
  "block.minecraft.cyan_carpet": "Covor turcoaz",
  "block.minecraft.cyan_concrete": "Beton turcoaz",
  "block.minecraft.cyan_concrete_powder": "Beton uscat turcoaz",
  "block.minecraft.cyan_glazed_terracotta": "Teracotă smălțuită turcoaz",
  "block.minecraft.cyan_shulker_box": "Cutie de shulker turcoaz",
  "block.minecraft.cyan_stained_glass": "Sticlă turcoaz",
  "block.minecraft.cyan_stained_glass_pane": "Geam turcoaz",
  "block.minecraft.cyan_terracotta": "Teracotă turcoaz",
  "block.minecraft.cyan_wool": "Lână turcoaz",
  "block.minecraft.damaged_anvil": "Nicovală stricată",
  "block.minecraft.dandelion": "Păpădie",
  "block.minecraft.dark_oak_button": "Buton de stejar negru",
  "block.minecraft.dark_oak_door": "Ușă de stejar negru",
  "block.minecraft.dark_oak_fence": "Gard de stejar negru",
  "block.minecraft.dark_oak_fence_gate": "Portiță de stejar negru",
  "block.minecraft.dark_oak_hanging_sign": "Semn agățat de stejar negru",
  "block.minecraft.dark_oak_leaves": "Frunze de stejar negru",
  "block.minecraft.dark_oak_log": "Buștean de stejar negru",
  "block.minecraft.dark_oak_planks": "Scânduri de stejar negru",
  "block.minecraft.dark_oak_pressure_plate": "Placă de presiune de stejar negru",
  "block.minecraft.dark_oak_sapling": "Puiet de stejar negru",
  "block.minecraft.dark_oak_shelf": "Raft de stejar negru",
  "block.minecraft.dark_oak_sign": "Semn de stejar negru",
  "block.minecraft.dark_oak_slab": "Lespede de stejar negru",
  "block.minecraft.dark_oak_stairs": "Trepte de stejar negru",
  "block.minecraft.dark_oak_trapdoor": "Trapă de stejar negru",
  "block.minecraft.dark_oak_wall_hanging_sign": "Semn agățat de stejar negru pe perete",
  "block.minecraft.dark_oak_wall_sign": "Semn de stejar negru pe perete",
  "block.minecraft.dark_oak_wood": "Lemn de stejar negru",
  "block.minecraft.dark_prismarine": "Prismarin întunecat",
  "block.minecraft.dark_prismarine_slab": "Lespede de prismarin întunecat",
  "block.minecraft.dark_prismarine_stairs": "Trepte de prismarin întunecat",
  "block.minecraft.daylight_detector": "Detector solar",
  "block.minecraft.dead_brain_coral": "Coral creier mort",
  "block.minecraft.dead_brain_coral_block": "Bloc de coral creier mort",
  "block.minecraft.dead_brain_coral_fan": "Gorgonie creier moartă",
  "block.minecraft.dead_brain_coral_wall_fan": "Gorgonie creier moartă pe perete",
  "block.minecraft.dead_bubble_coral": "Coral balon mort",
  "block.minecraft.dead_bubble_coral_block": "Bloc de coral balon mort",
  "block.minecraft.dead_bubble_coral_fan": "Gorgonie balon moartă",
  "block.minecraft.dead_bubble_coral_wall_fan": "Gorgonie balon moartă pe perete",
  "block.minecraft.dead_bush": "Tufă uscată",
  "block.minecraft.dead_fire_coral": "Coral de foc mort",
  "block.minecraft.dead_fire_coral_block": "Bloc de coral de foc mort",
  "block.minecraft.dead_fire_coral_fan": "Gorgonie de foc moartă",
  "block.minecraft.dead_fire_coral_wall_fan": "Gorgonie de foc moartă pe perete",
  "block.minecraft.dead_horn_coral": "Coral rugos mort",
  "block.minecraft.dead_horn_coral_block": "Bloc de coral rugos mort",
  "block.minecraft.dead_horn_coral_fan": "Gorgonie rugoasă moartă",
  "block.minecraft.dead_horn_coral_wall_fan": "Gorgonie rugoasă moartă pe perete",
  "block.minecraft.dead_tube_coral": "Coral tubular mort",
  "block.minecraft.dead_tube_coral_block": "Bloc de coral tubular mort",
  "block.minecraft.dead_tube_coral_fan": "Gorgonie tubulară moartă",
  "block.minecraft.dead_tube_coral_wall_fan": "Gorgonie tubulară moartă pe perete",
  "block.minecraft.decorated_pot": "Vas decorat",
  "block.minecraft.deepslate": "Ardezie adâncă",
  "block.minecraft.deepslate_brick_slab": "Lespede de cărămizi de ardezie adâncă",
  "block.minecraft.deepslate_brick_stairs": "Trepte de cărămizi de ardezie adâncă",
  "block.minecraft.deepslate_brick_wall": "Zid de cărămizi ardezie adâncă",
  "block.minecraft.deepslate_bricks": "Cărămizi de ardezie adâncă",
  "block.minecraft.deepslate_coal_ore": "Minereu de cărbune de ardezie adâncă",
  "block.minecraft.deepslate_copper_ore": "Minereu de cupru de ardezie adâncă",
  "block.minecraft.deepslate_diamond_ore": "Minereu de diamant de ardezie adâncă",
  "block.minecraft.deepslate_emerald_ore": "Minereu de smarald de ardezie adâncă",
  "block.minecraft.deepslate_gold_ore": "Minereu de aur de ardezie adâncă",
  "block.minecraft.deepslate_iron_ore": "Minereu de fier de ardezie adâncă",
  "block.minecraft.deepslate_lapis_ore": "Minereu de lapislazuli de ardezie adâncă",
  "block.minecraft.deepslate_redstone_ore": "Minereu de redstone de ardezie adâncă",
  "block.minecraft.deepslate_tile_slab": "Lespede de plăci de ardezie adâncă",
  "block.minecraft.deepslate_tile_stairs": "Trepte de plăci de ardezie adâncă",
  "block.minecraft.deepslate_tile_wall": "Zid de plăci de ardezie adâncă",
  "block.minecraft.deepslate_tiles": "Plăci de ardezie adâncă",
  "block.minecraft.detector_rail": "Șine detectoare",
  "block.minecraft.diamond_block": "Bloc de diamant",
  "block.minecraft.diamond_ore": "Minereu de diamant",
  "block.minecraft.diorite": "Diorit",
  "block.minecraft.diorite_slab": "Lespede de diorit",
  "block.minecraft.diorite_stairs": "Trepte de diorit",
  "block.minecraft.diorite_wall": "Zid de diorit",
  "block.minecraft.dirt": "Pământ",
  "block.minecraft.dirt_path": "Potecă de pământ",
  "block.minecraft.dispenser": "Distribuitor",
  "block.minecraft.dragon_egg": "Ou de dragon",
  "block.minecraft.dragon_head": "Cap de dragon",
  "block.minecraft.dragon_wall_head": "Cap de dragon pe perete",
  "block.minecraft.dried_ghast": "Ghast uscat",
  "block.minecraft.dried_kelp_block": "Bloc de alge uscate",
  "block.minecraft.dripstone_block": "Bloc de speleotemă",
  "block.minecraft.dropper": "Aruncător",
  "block.minecraft.emerald_block": "Bloc de smarald",
  "block.minecraft.emerald_ore": "Minereu de smarald",
  "block.minecraft.enchanting_table": "Masă de farmece",
  "block.minecraft.end_gateway": "Poartă de End",
  "block.minecraft.end_portal": "Portal spre End",
  "block.minecraft.end_portal_frame": "Cadru de portal spre End",
  "block.minecraft.end_rod": "Bară din End",
  "block.minecraft.end_stone": "Piatră din End",
  "block.minecraft.end_stone_brick_slab": "Lespede de cărămizi de piatră din End",
  "block.minecraft.end_stone_brick_stairs": "Trepte de cărămizi de piatră din End",
  "block.minecraft.end_stone_brick_wall": "Zid de cărămizi de piatră din End",
  "block.minecraft.end_stone_bricks": "Cărămizi de piatră din End",
  "block.minecraft.ender_chest": "Cufăr de Ender",
  "block.minecraft.exposed_chiseled_copper": "Bloc de cupru sculptat expus",
  "block.minecraft.exposed_copper": "Bloc de cupru expus",
  "block.minecraft.exposed_copper_bars": "Gratii de cupru expuse",
  "block.minecraft.exposed_copper_bulb": "Bec de cupru expus",
  "block.minecraft.exposed_copper_chain": "Lanț de cupru expus",
  "block.minecraft.exposed_copper_chest": "Cufăr de cupru expus",
  "block.minecraft.exposed_copper_door": "Ușă de cupru expusă",
  "block.minecraft.exposed_copper_golem_statue": "Statuie de golem de cupru expus",
  "block.minecraft.exposed_copper_grate": "Grilaj de cupru expus",
  "block.minecraft.exposed_copper_lantern": "Felinar de cupru expus",
  "block.minecraft.exposed_copper_trapdoor": "Trapă de cupru expusă",
  "block.minecraft.exposed_cut_copper": "Bloc de cupru tăiat expus",
  "block.minecraft.exposed_cut_copper_slab": "Lespede de cupru tăiată expusă",
  "block.minecraft.exposed_cut_copper_stairs": "Trepte de cupru tăiate expuse",
  "block.minecraft.exposed_lightning_rod": "Paratrăsnet expus",
  "block.minecraft.farmland": "Teren agricol",
  "block.minecraft.fern": "Ferigă",
  "block.minecraft.fire": "Foc",
  "block.minecraft.fire_coral": "Coral de foc",
  "block.minecraft.fire_coral_block": "Bloc de coral de foc",
  "block.minecraft.fire_coral_fan": "Gorgonie de foc",
  "block.minecraft.fire_coral_wall_fan": "Gorgonie de foc pe perete",
  "block.minecraft.firefly_bush": "Tufiș cu licurici",
  "block.minecraft.fletching_table": "Masă de făcut săgeți",
  "block.minecraft.flower_pot": "Ghiveci de flori",
  "block.minecraft.flowering_azalea": "Azalee înflorită",
  "block.minecraft.flowering_azalea_leaves": "Frunze de azalee înflorită",
  "block.minecraft.frogspawn": "Ou de broască",
  "block.minecraft.frosted_ice": "Gheață brumată",
  "block.minecraft.furnace": "Cuptor",
  "block.minecraft.gilded_blackstone": "Piatră neagră aurită",
  "block.minecraft.glass": "Sticlă",
  "block.minecraft.glass_pane": "Geam",
  "block.minecraft.glow_lichen": "Lichen strălucitor",
  "block.minecraft.glowstone": "Piatră strălucitoare",
  "block.minecraft.gold_block": "Bloc de aur",
  "block.minecraft.gold_ore": "Minereu de aur",
  "block.minecraft.golden_dandelion": "Păpădie de aur",
  "block.minecraft.granite": "Granit",
  "block.minecraft.granite_slab": "Lespede de granit",
  "block.minecraft.granite_stairs": "Trepte de granit",
  "block.minecraft.granite_wall": "Zid de granit",
  "block.minecraft.grass": "Iarbă",
  "block.minecraft.grass_block": "Bloc de iarbă",
  "block.minecraft.gravel": "Pietriș",
  "block.minecraft.gray_banner": "Stindard gri",
  "block.minecraft.gray_bed": "Pat gri",
  "block.minecraft.gray_candle": "Lumânare gri",
  "block.minecraft.gray_candle_cake": "Tort cu lumânare gri",
  "block.minecraft.gray_carpet": "Covor gri",
  "block.minecraft.gray_concrete": "Beton gri",
  "block.minecraft.gray_concrete_powder": "Beton uscat gri",
  "block.minecraft.gray_glazed_terracotta": "Teracotă smălțuită gri",
  "block.minecraft.gray_shulker_box": "Cutie de shulker gri",
  "block.minecraft.gray_stained_glass": "Sticlă gri",
  "block.minecraft.gray_stained_glass_pane": "Geam gri",
  "block.minecraft.gray_terracotta": "Teracotă gri",
  "block.minecraft.gray_wool": "Lână gri",
  "block.minecraft.green_banner": "Stindard verde",
  "block.minecraft.green_bed": "Pat verde",
  "block.minecraft.green_candle": "Lumânare verde",
  "block.minecraft.green_candle_cake": "Tort cu lumânare verde",
  "block.minecraft.green_carpet": "Covor verde",
  "block.minecraft.green_concrete": "Beton verde",
  "block.minecraft.green_concrete_powder": "Beton uscat verde",
  "block.minecraft.green_glazed_terracotta": "Teracotă smălțuită verde",
  "block.minecraft.green_shulker_box": "Cutie de shulker verde",
  "block.minecraft.green_stained_glass": "Sticlă verde",
  "block.minecraft.green_stained_glass_pane": "Geam verde",
  "block.minecraft.green_terracotta": "Teracotă verde",
  "block.minecraft.green_wool": "Lână verde",
  "block.minecraft.grindstone": "Tocilă",
  "block.minecraft.hanging_roots": "Rădăcini suspendate",
  "block.minecraft.hay_block": "Balot de paie",
  "block.minecraft.heavy_core": "Nucleu greu",
  "block.minecraft.heavy_weighted_pressure_plate": "Placă de presiune ponderată grea",
  "block.minecraft.honey_block": "Bloc de miere",
  "block.minecraft.honeycomb_block": "Bloc de fagure",
  "block.minecraft.hopper": "Pâlnie",
  "block.minecraft.horn_coral": "Coral rugos",
  "block.minecraft.horn_coral_block": "Bloc de coral rugos",
  "block.minecraft.horn_coral_fan": "Gorgonie rugoasă",
  "block.minecraft.horn_coral_wall_fan": "Gorgonie rugoasă pe perete",
  "block.minecraft.ice": "Gheață",
  "block.minecraft.infested_chiseled_stone_bricks": "Cărămizi de piatră sculptată infestate",
  "block.minecraft.infested_cobblestone": "Pietruială infestată",
  "block.minecraft.infested_cracked_stone_bricks": "Cărămizi de piatră crăpate infestate",
  "block.minecraft.infested_deepslate": "Ardezie adâncă infestate",
  "block.minecraft.infested_mossy_stone_bricks": "Cărămizi de piatră cu mușchi infestate",
  "block.minecraft.infested_stone": "Piatră infestată",
  "block.minecraft.infested_stone_bricks": "Cărămizi de piatră infestate",
  "block.minecraft.iron_bars": "Gratii de fier",
  "block.minecraft.iron_block": "Bloc de fier",
  "block.minecraft.iron_chain": "Lanț de fier",
  "block.minecraft.iron_door": "Ușă de fier",
  "block.minecraft.iron_ore": "Minereu de fier",
  "block.minecraft.iron_trapdoor": "Trapă de fier",
  "block.minecraft.jack_o_lantern": "Dovleac de Halloween",
  "block.minecraft.jigsaw": "Bloc de construcție",
  "block.minecraft.jukebox": "Tonomat",
  "block.minecraft.jungle_button": "Buton de junglă",
  "block.minecraft.jungle_door": "Ușă de junglă",
  "block.minecraft.jungle_fence": "Gard de junglă",
  "block.minecraft.jungle_fence_gate": "Portiță de junglă",
  "block.minecraft.jungle_hanging_sign": "Semn agățat de junglă",
  "block.minecraft.jungle_leaves": "Frunze de junglă",
  "block.minecraft.jungle_log": "Buștean de junglă",
  "block.minecraft.jungle_planks": "Scânduri de junglă",
  "block.minecraft.jungle_pressure_plate": "Placă de presiune de junglă",
  "block.minecraft.jungle_sapling": "Puiet de junglă",
  "block.minecraft.jungle_shelf": "Raft de junglă",
  "block.minecraft.jungle_sign": "Semn de junglă",
  "block.minecraft.jungle_slab": "Lespede de junglă",
  "block.minecraft.jungle_stairs": "Trepte de junglă",
  "block.minecraft.jungle_trapdoor": "Trapă de junglă",
  "block.minecraft.jungle_wall_hanging_sign": "Semn agățat de junglă pe perete",
  "block.minecraft.jungle_wall_sign": "Semn de junglă pe perete",
  "block.minecraft.jungle_wood": "Lemn de junglă",
  "block.minecraft.kelp": "Algă",
  "block.minecraft.kelp_plant": "Tulpină de algă",
  "block.minecraft.ladder": "Scară",
  "block.minecraft.lantern": "Felinar",
  "block.minecraft.lapis_block": "Bloc de lapislazuli",
  "block.minecraft.lapis_ore": "Minereu de lapislazuli",
  "block.minecraft.large_amethyst_bud": "Boboc mare de ametist",
  "block.minecraft.large_fern": "Ferigă mare",
  "block.minecraft.lava": "Lavă",
  "block.minecraft.lava_cauldron": "Cazan cu lavă",
  "block.minecraft.leaf_litter": "Așternut de frunze",
  "block.minecraft.lectern": "Pupitru",
  "block.minecraft.lever": "Manetă",
  "block.minecraft.light": "Lumină",
  "block.minecraft.light_blue_banner": "Stindard bleu",
  "block.minecraft.light_blue_bed": "Pat bleu",
  "block.minecraft.light_blue_candle": "Lumânare albastru-deschis",
  "block.minecraft.light_blue_candle_cake": "Tort cu lumânare bleu",
  "block.minecraft.light_blue_carpet": "Covor bleu",
  "block.minecraft.light_blue_concrete": "Beton bleu",
  "block.minecraft.light_blue_concrete_powder": "Beton uscat bleu",
  "block.minecraft.light_blue_glazed_terracotta": "Teracotă smălțuită bleu",
  "block.minecraft.light_blue_shulker_box": "Cutie de shulker bleu",
  "block.minecraft.light_blue_stained_glass": "Sticlă bleu",
  "block.minecraft.light_blue_stained_glass_pane": "Geam bleu",
  "block.minecraft.light_blue_terracotta": "Teracotă bleu",
  "block.minecraft.light_blue_wool": "Lână bleu",
  "block.minecraft.light_gray_banner": "Stindard gri-deschis",
  "block.minecraft.light_gray_bed": "Pat gri-deschis",
  "block.minecraft.light_gray_candle": "Lumânare gri-deschis",
  "block.minecraft.light_gray_candle_cake": "Tort cu lumânare gri-deschis",
  "block.minecraft.light_gray_carpet": "Covor gri-deschis",
  "block.minecraft.light_gray_concrete": "Beton gri-deschis",
  "block.minecraft.light_gray_concrete_powder": "Beton uscat gri-deschis",
  "block.minecraft.light_gray_glazed_terracotta": "Teracotă smălțuită gri-deschis",
  "block.minecraft.light_gray_shulker_box": "Cutie de shulker gri-deschis",
  "block.minecraft.light_gray_stained_glass": "Sticlă gri-deschis",
  "block.minecraft.light_gray_stained_glass_pane": "Geam gri-deschis",
  "block.minecraft.light_gray_terracotta": "Teracotă gri-deschis",
  "block.minecraft.light_gray_wool": "Lână gri-deschis",
  "block.minecraft.light_weighted_pressure_plate": "Placă de presiune ponderată ușoară",
  "block.minecraft.lightning_rod": "Paratrăsnet",
  "block.minecraft.lilac": "Liliac",
  "block.minecraft.lily_of_the_valley": "Lăcrămioară",
  "block.minecraft.lily_pad": "Nufăr",
  "block.minecraft.lime_banner": "Stindard verde-deschis",
  "block.minecraft.lime_bed": "Pat verde-deschis",
  "block.minecraft.lime_candle": "Lumânare verde-deschis",
  "block.minecraft.lime_candle_cake": "Tort cu lumânare verde-deschis",
  "block.minecraft.lime_carpet": "Covor verde-deschis",
  "block.minecraft.lime_concrete": "Beton verde-deschis",
  "block.minecraft.lime_concrete_powder": "Beton uscat verde-deschis",
  "block.minecraft.lime_glazed_terracotta": "Teracotă smălțuită verde-deschis",
  "block.minecraft.lime_shulker_box": "Cutie de shulker verde-deschis",
  "block.minecraft.lime_stained_glass": "Sticlă verde-deschis",
  "block.minecraft.lime_stained_glass_pane": "Geam verde-deschis",
  "block.minecraft.lime_terracotta": "Teracotă verde-deschis",
  "block.minecraft.lime_wool": "Lână verde-deschis",
  "block.minecraft.lodestone": "Magnetită",
  "block.minecraft.loom": "Război de țesut",
  "block.minecraft.magenta_banner": "Stindard magenta",
  "block.minecraft.magenta_bed": "Pat magenta",
  "block.minecraft.magenta_candle": "Lumânare magenta",
  "block.minecraft.magenta_candle_cake": "Tort cu lumânare magenta",
  "block.minecraft.magenta_carpet": "Covor magenta",
  "block.minecraft.magenta_concrete": "Beton magenta",
  "block.minecraft.magenta_concrete_powder": "Beton uscat magenta",
  "block.minecraft.magenta_glazed_terracotta": "Teracotă smălțuită magenta",
  "block.minecraft.magenta_shulker_box": "Cutie de shulker magenta",
  "block.minecraft.magenta_stained_glass": "Sticlă magenta",
  "block.minecraft.magenta_stained_glass_pane": "Geam magenta",
  "block.minecraft.magenta_terracotta": "Teracotă magenta",
  "block.minecraft.magenta_wool": "Lână magenta",
  "block.minecraft.magma_block": "Bloc de magmă",
  "block.minecraft.mangrove_button": "Buton de mangrovă",
  "block.minecraft.mangrove_door": "Ușă de mangrovă",
  "block.minecraft.mangrove_fence": "Gard de mangrovă",
  "block.minecraft.mangrove_fence_gate": "Portiță de mangrovă",
  "block.minecraft.mangrove_hanging_sign": "Semn agățat de mangrovă",
  "block.minecraft.mangrove_leaves": "Frunze de mangrovă",
  "block.minecraft.mangrove_log": "Buștean de mangrovă",
  "block.minecraft.mangrove_planks": "Scânduri de mangrovă",
  "block.minecraft.mangrove_pressure_plate": "Placă de presiune de mangrovă",
  "block.minecraft.mangrove_propagule": "Răsad de mangrovă",
  "block.minecraft.mangrove_roots": "Rădăcini de mangrovă",
  "block.minecraft.mangrove_shelf": "Raft de mangrovă",
  "block.minecraft.mangrove_sign": "Semn de mangrovă",
  "block.minecraft.mangrove_slab": "Lespede de mangrovă",
  "block.minecraft.mangrove_stairs": "Trepte de mangrovă",
  "block.minecraft.mangrove_trapdoor": "Trapă de mangrovă",
  "block.minecraft.mangrove_wall_hanging_sign": "Semn agățat de mangrovă pe perete",
  "block.minecraft.mangrove_wall_sign": "Semn de mangrovă pe perete",
  "block.minecraft.mangrove_wood": "Lemn de mangrovă",
  "block.minecraft.medium_amethyst_bud": "Boboc mediu de ametist",
  "block.minecraft.melon": "Pepene",
  "block.minecraft.melon_stem": "Tulpină de pepene",
  "block.minecraft.moss_block": "Bloc de mușchi",
  "block.minecraft.moss_carpet": "Covor de mușchi",
  "block.minecraft.mossy_cobblestone": "Pietruială cu mușchi",
  "block.minecraft.mossy_cobblestone_slab": "Lespede de pietruială cu mușchi",
  "block.minecraft.mossy_cobblestone_stairs": "Trepte de pietruială cu mușchi",
  "block.minecraft.mossy_cobblestone_wall": "Zid de pietruială cu mușchi",
  "block.minecraft.mossy_stone_brick_slab": "Lespede de cărămizi de piatră cu mușchi",
  "block.minecraft.mossy_stone_brick_stairs": "Trepte de cărămizi de piatră cu mușchi",
  "block.minecraft.mossy_stone_brick_wall": "Zid de cărămizi de piatră cu mușchi",
  "block.minecraft.mossy_stone_bricks": "Cărămizi de piatră cu mușchi",
  "block.minecraft.moving_piston": "Bloc în mișcare",
  "block.minecraft.mud": "Noroi",
  "block.minecraft.mud_brick_slab": "Lespede de cărămizi de noroi",
  "block.minecraft.mud_brick_stairs": "Trepte de cărămizi de noroi",
  "block.minecraft.mud_brick_wall": "Zid de cărămizi de noroi",
  "block.minecraft.mud_bricks": "Cărămizi de noroi",
  "block.minecraft.muddy_mangrove_roots": "Rădăcini noroioase de mangrovă",
  "block.minecraft.mushroom_stem": "Picior de ciupercă",
  "block.minecraft.mycelium": "Miceliu",
  "block.minecraft.nether_brick_fence": "Gard de cărămizi de Nether",
  "block.minecraft.nether_brick_slab": "Lespede de cărămizi de Nether",
  "block.minecraft.nether_brick_stairs": "Trepte de cărămizi de Nether",
  "block.minecraft.nether_brick_wall": "Zid de cărămizi de Nether",
  "block.minecraft.nether_bricks": "Cărămizi de Nether",
  "block.minecraft.nether_gold_ore": "Minereu de aur din Nether",
  "block.minecraft.nether_portal": "Portal spre Nether",
  "block.minecraft.nether_quartz_ore": "Minereu de cuarț de Nether",
  "block.minecraft.nether_sprouts": "Lăstari din Nether",
  "block.minecraft.nether_wart": "Neg din Nether",
  "block.minecraft.nether_wart_block": "Bloc de negi din Nether",
  "block.minecraft.netherite_block": "Bloc de netherit",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Bloc muzical",
  "block.minecraft.oak_button": "Buton de stejar",
  "block.minecraft.oak_door": "Ușă de stejar",
  "block.minecraft.oak_fence": "Gard de stejar",
  "block.minecraft.oak_fence_gate": "Portiță de stejar",
  "block.minecraft.oak_hanging_sign": "Semn agățat de stejar",
  "block.minecraft.oak_leaves": "Frunze de stejar",
  "block.minecraft.oak_log": "Buștean de stejar",
  "block.minecraft.oak_planks": "Scânduri de stejar",
  "block.minecraft.oak_pressure_plate": "Placă de presiune de stejar",
  "block.minecraft.oak_sapling": "Puiet de stejar",
  "block.minecraft.oak_shelf": "Raft de stejar",
  "block.minecraft.oak_sign": "Semn de stejar",
  "block.minecraft.oak_slab": "Lespede de stejar",
  "block.minecraft.oak_stairs": "Trepte de stejar",
  "block.minecraft.oak_trapdoor": "Trapă de stejar",
  "block.minecraft.oak_wall_hanging_sign": "Semn agățat de stejar pe perete",
  "block.minecraft.oak_wall_sign": "Semn de stejar pe perete",
  "block.minecraft.oak_wood": "Lemn de stejar",
  "block.minecraft.observer": "Observator",
  "block.minecraft.obsidian": "Obsidian",
  "block.minecraft.ochre_froglight": "Lumină de broască ocru",
  "block.minecraft.ominous_banner": "Stindard de rău augur",
  "block.minecraft.open_eyeblossom": "Floare-ochi deschisă",
  "block.minecraft.orange_banner": "Stindard portocaliu",
  "block.minecraft.orange_bed": "Pat portocaliu",
  "block.minecraft.orange_candle": "Lumânare portocalie",
  "block.minecraft.orange_candle_cake": "Tort cu lumânare portocalie",
  "block.minecraft.orange_carpet": "Covor portocaliu",
  "block.minecraft.orange_concrete": "Beton portocaliu",
  "block.minecraft.orange_concrete_powder": "Beton uscat portocaliu",
  "block.minecraft.orange_glazed_terracotta": "Teracotă smălțuită portocalie",
  "block.minecraft.orange_shulker_box": "Cutie de shulker portocalie",
  "block.minecraft.orange_stained_glass": "Sticlă portocalie",
  "block.minecraft.orange_stained_glass_pane": "Geam portocaliu",
  "block.minecraft.orange_terracotta": "Teracotă portocalie",
  "block.minecraft.orange_tulip": "Lalea portocalie",
  "block.minecraft.orange_wool": "Lână portocalie",
  "block.minecraft.oxeye_daisy": "Margaretă",
  "block.minecraft.oxidized_chiseled_copper": "Bloc de cupru sculptat oxidat",
  "block.minecraft.oxidized_copper": "Bloc de cupru oxidat",
  "block.minecraft.oxidized_copper_bars": "Gratii de cupru oxidate",
  "block.minecraft.oxidized_copper_bulb": "Bec de cupru oxidat",
  "block.minecraft.oxidized_copper_chain": "Lanț de cupru oxidat",
  "block.minecraft.oxidized_copper_chest": "Cufăr de cupru oxidat",
  "block.minecraft.oxidized_copper_door": "Ușă de cupru oxidată",
  "block.minecraft.oxidized_copper_golem_statue": "Statuie de golem de cupru oxidat",
  "block.minecraft.oxidized_copper_grate": "Grilaj de cupru oxidat",
  "block.minecraft.oxidized_copper_lantern": "Felinar de cupru oxidat",
  "block.minecraft.oxidized_copper_trapdoor": "Trapă de cupru oxidată",
  "block.minecraft.oxidized_cut_copper": "Bloc de cupru tăiat oxidat",
  "block.minecraft.oxidized_cut_copper_slab": "Lespede de cupru tăiată oxidată",
  "block.minecraft.oxidized_cut_copper_stairs": "Trepte de cupru tăiate oxidate",
  "block.minecraft.oxidized_lightning_rod": "Paratrăsnet oxidat",
  "block.minecraft.packed_ice": "Gheață compactă",
  "block.minecraft.packed_mud": "Noroi solid",
  "block.minecraft.pale_hanging_moss": "Mușchi palid agățat",
  "block.minecraft.pale_moss_block": "Bloc de mușchi palid",
  "block.minecraft.pale_moss_carpet": "Covor de mușchi palid",
  "block.minecraft.pale_oak_button": "Buton de stejar palid",
  "block.minecraft.pale_oak_door": "Ușă de stejar palid",
  "block.minecraft.pale_oak_fence": "Gard de stejar palid",
  "block.minecraft.pale_oak_fence_gate": "Portiță de stejar palid",
  "block.minecraft.pale_oak_hanging_sign": "Semn agățat de stejar palid",
  "block.minecraft.pale_oak_leaves": "Frunze de stejar palid",
  "block.minecraft.pale_oak_log": "Buștean de stejar palid",
  "block.minecraft.pale_oak_planks": "Scânduri de stejar palid",
  "block.minecraft.pale_oak_pressure_plate": "Placă de presiune de stejar palid",
  "block.minecraft.pale_oak_sapling": "Puiet de stejar palid",
  "block.minecraft.pale_oak_shelf": "Raft de stejar palid",
  "block.minecraft.pale_oak_sign": "Semn de stejar palid",
  "block.minecraft.pale_oak_slab": "Lespede de stejar palid",
  "block.minecraft.pale_oak_stairs": "Trepte de stejar palid",
  "block.minecraft.pale_oak_trapdoor": "Trapă de stejar palid",
  "block.minecraft.pale_oak_wall_hanging_sign": "Semn agățat de stejar palid",
  "block.minecraft.pale_oak_wall_sign": "Semn de stejar palid",
  "block.minecraft.pale_oak_wood": "Lemn de stejar palid",
  "block.minecraft.pearlescent_froglight": "Lumină de broască sidefă",
  "block.minecraft.peony": "Bujor",
  "block.minecraft.petrified_oak_slab": "Lespede de stejar pietrificată",
  "block.minecraft.piglin_head": "Cap de piglin",
  "block.minecraft.piglin_wall_head": "Cap de piglin pe perete",
  "block.minecraft.pink_banner": "Stindard roz",
  "block.minecraft.pink_bed": "Pat roz",
  "block.minecraft.pink_candle": "Lumânare roz",
  "block.minecraft.pink_candle_cake": "Tort cu lumânare roz",
  "block.minecraft.pink_carpet": "Covor roz",
  "block.minecraft.pink_concrete": "Beton roz",
  "block.minecraft.pink_concrete_powder": "Beton uscat roz",
  "block.minecraft.pink_glazed_terracotta": "Teracotă smălțuită roz",
  "block.minecraft.pink_petals": "Petale roz",
  "block.minecraft.pink_shulker_box": "Cutie de shulker roz",
  "block.minecraft.pink_stained_glass": "Sticlă roz",
  "block.minecraft.pink_stained_glass_pane": "Geam roz",
  "block.minecraft.pink_terracotta": "Teracotă roz",
  "block.minecraft.pink_tulip": "Lalea roz",
  "block.minecraft.pink_wool": "Lână roz",
  "block.minecraft.piston": "Piston",
  "block.minecraft.piston_head": "Cap de piston",
  "block.minecraft.pitcher_crop": "Cultură de plantă-urcior",
  "block.minecraft.pitcher_plant": "Plantă-urcior",
  "block.minecraft.player_head": "Cap de jucător",
  "block.minecraft.player_head.named": "Capul lui %s",
  "block.minecraft.player_wall_head": "Cap de jucător pe perete",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Speleotemă ascuțită",
  "block.minecraft.polished_andesite": "Andezit șlefuit",
  "block.minecraft.polished_andesite_slab": "Lespede de andezit șlefuit",
  "block.minecraft.polished_andesite_stairs": "Trepte de andezit șlefuit",
  "block.minecraft.polished_basalt": "Bazalt șlefuit",
  "block.minecraft.polished_blackstone": "Piatră neagră șlefuită",
  "block.minecraft.polished_blackstone_brick_slab": "Lespede de cărămizi de piatră neagră șlefuită",
  "block.minecraft.polished_blackstone_brick_stairs": "Trepte de cărămizi de piatră neagră șlefuită",
  "block.minecraft.polished_blackstone_brick_wall": "Zid de cărămizi de piatră neagră șlefuită",
  "block.minecraft.polished_blackstone_bricks": "Cărămizi de piatră neagră șlefuită",
  "block.minecraft.polished_blackstone_button": "Buton de piatră neagră șlefuită",
  "block.minecraft.polished_blackstone_pressure_plate": "Placă de presiune de piatră neagră șlefuită",
  "block.minecraft.polished_blackstone_slab": "Lespede de piatră neagră șlefuită",
  "block.minecraft.polished_blackstone_stairs": "Trepte de piatră neagră șlefuită",
  "block.minecraft.polished_blackstone_wall": "Zid de piatră neagră șlefuită",
  "block.minecraft.polished_deepslate": "Ardezie adâncă șlefuit",
  "block.minecraft.polished_deepslate_slab": "Lespede de ardezie adâncă șlefuită",
  "block.minecraft.polished_deepslate_stairs": "Trepte de ardezie adâncă șlefuit",
  "block.minecraft.polished_deepslate_wall": "Zid de ardezie adâncă șlefuit",
  "block.minecraft.polished_diorite": "Diorit șlefuit",
  "block.minecraft.polished_diorite_slab": "Lespede de diorit șlefuit",
  "block.minecraft.polished_diorite_stairs": "Trepte de diorit șlefuit",
  "block.minecraft.polished_granite": "Granit șlefuit",
  "block.minecraft.polished_granite_slab": "Lespede de granit șlefuit",
  "block.minecraft.polished_granite_stairs": "Trepte de granit șlefuit",
  "block.minecraft.polished_tuff": "Tuf șlefuit",
  "block.minecraft.polished_tuff_slab": "Lespede de tuf șlefuit",
  "block.minecraft.polished_tuff_stairs": "Trepte de tuf șlefuit",
  "block.minecraft.polished_tuff_wall": "Zid de tuf șlefuit",
  "block.minecraft.poppy": "Mac",
  "block.minecraft.potatoes": "Cartofi",
  "block.minecraft.potted_acacia_sapling": "Puiet de salcâm în ghiveci",
  "block.minecraft.potted_allium": "Arpagic în ghiveci",
  "block.minecraft.potted_azalea_bush": "Azalee în ghiveci",
  "block.minecraft.potted_azure_bluet": "Lăptișor în ghiveci",
  "block.minecraft.potted_bamboo": "Bambus în ghiveci",
  "block.minecraft.potted_birch_sapling": "Puiet de mesteacăn în ghiveci",
  "block.minecraft.potted_blue_orchid": "Orhidee albastră în ghiveci",
  "block.minecraft.potted_brown_mushroom": "Ciupercă maro în ghiveci",
  "block.minecraft.potted_cactus": "Cactus în ghiveci",
  "block.minecraft.potted_cherry_sapling": "Puiet de cireș în ghiveci",
  "block.minecraft.potted_closed_eyeblossom": "Floare-ochi închisă în ghiveci",
  "block.minecraft.potted_cornflower": "Albăstrea în ghiveci",
  "block.minecraft.potted_crimson_fungus": "Ciupercă stacojie în ghiveci",
  "block.minecraft.potted_crimson_roots": "Rădăcini stacojii în ghiveci",
  "block.minecraft.potted_dandelion": "Păpădie în ghiveci",
  "block.minecraft.potted_dark_oak_sapling": "Puiet de stejar negru în ghiveci",
  "block.minecraft.potted_dead_bush": "Tufă uscată în ghiveci",
  "block.minecraft.potted_fern": "Ferigă în ghiveci",
  "block.minecraft.potted_flowering_azalea_bush": "Azalee înflorită în ghiveci",
  "block.minecraft.potted_golden_dandelion": "Păpădie de aur în ghiveci",
  "block.minecraft.potted_jungle_sapling": "Puiet de junglă în ghiveci",
  "block.minecraft.potted_lily_of_the_valley": "Lăcrămioară în ghiveci",
  "block.minecraft.potted_mangrove_propagule": "Răsad de mangrovă în ghiveci",
  "block.minecraft.potted_oak_sapling": "Puiet de stejar în ghiveci",
  "block.minecraft.potted_open_eyeblossom": "Floare-ochi deschisă în ghiveci",
  "block.minecraft.potted_orange_tulip": "Lalea portocalie în ghiveci",
  "block.minecraft.potted_oxeye_daisy": "Margaretă în ghiveci",
  "block.minecraft.potted_pale_oak_sapling": "Puiet de stejar palid în ghiveci",
  "block.minecraft.potted_pink_tulip": "Lalea roz în ghiveci",
  "block.minecraft.potted_poppy": "Mac în ghiveci",
  "block.minecraft.potted_red_mushroom": "Ciupercă roșie în ghiveci",
  "block.minecraft.potted_red_tulip": "Lalea roșie în ghiveci",
  "block.minecraft.potted_spruce_sapling": "Puiet de molid în ghiveci",
  "block.minecraft.potted_torchflower": "Floare-torță în ghiveci",
  "block.minecraft.potted_warped_fungus": "Ciupercă deformată în ghiveci",
  "block.minecraft.potted_warped_roots": "Rădăcini deformate în ghiveci",
  "block.minecraft.potted_white_tulip": "Lalea albă în ghiveci",
  "block.minecraft.potted_wither_rose": "Trandafir al witherului în ghiveci",
  "block.minecraft.powder_snow": "Zăpadă-pudră",
  "block.minecraft.powder_snow_cauldron": "Cazan cu zăpadă-pudră",
  "block.minecraft.powered_rail": "Șine propulsoare",
  "block.minecraft.prismarine": "Prismarin",
  "block.minecraft.prismarine_brick_slab": "Lespede de cărămizi de prismarin",
  "block.minecraft.prismarine_brick_stairs": "Trepte de cărămizi de prismarin",
  "block.minecraft.prismarine_bricks": "Cărămizi de prismarin",
  "block.minecraft.prismarine_slab": "Lespede de prismarin",
  "block.minecraft.prismarine_stairs": "Trepte de prismarin",
  "block.minecraft.prismarine_wall": "Zid de prismarin",
  "block.minecraft.pumpkin": "Dovleac",
  "block.minecraft.pumpkin_stem": "Tulpină de dovleac",
  "block.minecraft.purple_banner": "Stindard violet",
  "block.minecraft.purple_bed": "Pat violet",
  "block.minecraft.purple_candle": "Lumânare violet",
  "block.minecraft.purple_candle_cake": "Tort cu lumânare violetă",
  "block.minecraft.purple_carpet": "Covor violet",
  "block.minecraft.purple_concrete": "Beton violet",
  "block.minecraft.purple_concrete_powder": "Beton uscat violet",
  "block.minecraft.purple_glazed_terracotta": "Teracotă smălțuită violetă",
  "block.minecraft.purple_shulker_box": "Cutie de shulker violetă",
  "block.minecraft.purple_stained_glass": "Sticlă violetă",
  "block.minecraft.purple_stained_glass_pane": "Geam violet",
  "block.minecraft.purple_terracotta": "Teracotă violetă",
  "block.minecraft.purple_wool": "Lână violetă",
  "block.minecraft.purpur_block": "Bloc de purpur",
  "block.minecraft.purpur_pillar": "Coloană de purpur",
  "block.minecraft.purpur_slab": "Lespede de purpur",
  "block.minecraft.purpur_stairs": "Trepte de purpur",
  "block.minecraft.quartz_block": "Bloc de cuarț",
  "block.minecraft.quartz_bricks": "Cărămizi de cuarț",
  "block.minecraft.quartz_pillar": "Coloană de cuarț",
  "block.minecraft.quartz_slab": "Lespede de cuarț",
  "block.minecraft.quartz_stairs": "Trepte de cuarț",
  "block.minecraft.rail": "Șine",
  "block.minecraft.raw_copper_block": "Bloc de cupru brut",
  "block.minecraft.raw_gold_block": "Bloc de aur brut",
  "block.minecraft.raw_iron_block": "Bloc de fier brut",
  "block.minecraft.red_banner": "Stindard roșu",
  "block.minecraft.red_bed": "Pat roșu",
  "block.minecraft.red_candle": "Lumânare roșie",
  "block.minecraft.red_candle_cake": "Tort cu lumânare roșie",
  "block.minecraft.red_carpet": "Covor roșu",
  "block.minecraft.red_concrete": "Beton roșu",
  "block.minecraft.red_concrete_powder": "Beton uscat roșu",
  "block.minecraft.red_glazed_terracotta": "Teracotă smălțuită roșie",
  "block.minecraft.red_mushroom": "Ciupercă roșie",
  "block.minecraft.red_mushroom_block": "Bloc de ciupercă roșie",
  "block.minecraft.red_nether_brick_slab": "Lespede de cărămizi de Nether roșii",
  "block.minecraft.red_nether_brick_stairs": "Trepte de cărămizi de Nether roșii",
  "block.minecraft.red_nether_brick_wall": "Zid de cărămizi de Nether roșii",
  "block.minecraft.red_nether_bricks": "Cărămizi de Nether roșii",
  "block.minecraft.red_sand": "Nisip roșu",
  "block.minecraft.red_sandstone": "Gresie roșie",
  "block.minecraft.red_sandstone_slab": "Lespede de gresie roșie",
  "block.minecraft.red_sandstone_stairs": "Trepte de gresie roșie",
  "block.minecraft.red_sandstone_wall": "Zid de gresie roșie",
  "block.minecraft.red_shulker_box": "Cutie de shulker roșie",
  "block.minecraft.red_stained_glass": "Sticlă roșie",
  "block.minecraft.red_stained_glass_pane": "Geam roșu",
  "block.minecraft.red_terracotta": "Teracotă roșie",
  "block.minecraft.red_tulip": "Lalea roșie",
  "block.minecraft.red_wool": "Lână roșie",
  "block.minecraft.redstone_block": "Bloc de redstone",
  "block.minecraft.redstone_lamp": "Lampă de redstone",
  "block.minecraft.redstone_ore": "Minereu de redstone",
  "block.minecraft.redstone_torch": "Torță de redstone",
  "block.minecraft.redstone_wall_torch": "Torță de redstone pe perete",
  "block.minecraft.redstone_wire": "Fir de redstone",
  "block.minecraft.reinforced_deepslate": "Ardezie adâncă armată",
  "block.minecraft.repeater": "Repetor de redstone",
  "block.minecraft.repeating_command_block": "Bloc de comenzi cu repetiție",
  "block.minecraft.resin_block": "Bloc de rășină",
  "block.minecraft.resin_brick_slab": "Lespede de cărămizi de rășină",
  "block.minecraft.resin_brick_stairs": "Trepte de rășină",
  "block.minecraft.resin_brick_wall": "Zid de cărămizi de rășină",
  "block.minecraft.resin_bricks": "Cărămizi de rășină",
  "block.minecraft.resin_clump": "Bloc de bulgări de rășină",
  "block.minecraft.respawn_anchor": "Ancoră de reînviere",
  "block.minecraft.rooted_dirt": "Pământ cu rădăcini",
  "block.minecraft.rose_bush": "Tufă de trandafiri",
  "block.minecraft.sand": "Nisip",
  "block.minecraft.sandstone": "Gresie",
  "block.minecraft.sandstone_slab": "Lespede de gresie",
  "block.minecraft.sandstone_stairs": "Trepte de gresie",
  "block.minecraft.sandstone_wall": "Zid de gresie",
  "block.minecraft.scaffolding": "Schelă",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Catalizator sculk",
  "block.minecraft.sculk_sensor": "Senzor sculk",
  "block.minecraft.sculk_shrieker": "Sculk țipător",
  "block.minecraft.sculk_vein": "Venă de sculk",
  "block.minecraft.sea_lantern": "Felinar marin",
  "block.minecraft.sea_pickle": "Pirozom",
  "block.minecraft.seagrass": "Iarbă de mare",
  "block.minecraft.set_spawn": "Punct de reînviere definit",
  "block.minecraft.short_dry_grass": "Iarbă scurtă uscată",
  "block.minecraft.short_grass": "Iarbă scurtă",
  "block.minecraft.shroomlight": "Strălucipercă",
  "block.minecraft.shulker_box": "Cutie de shulker",
  "block.minecraft.skeleton_skull": "Craniu de schelet",
  "block.minecraft.skeleton_wall_skull": "Craniu de schelet pe perete",
  "block.minecraft.slime_block": "Bloc de mâzgă",
  "block.minecraft.small_amethyst_bud": "Boboc mic de ametist",
  "block.minecraft.small_dripleaf": "Frunză picurătoare mică",
  "block.minecraft.smithing_table": "Masă de fierărie",
  "block.minecraft.smoker": "Afumătoare",
  "block.minecraft.smooth_basalt": "Bazalt neted",
  "block.minecraft.smooth_quartz": "Bloc de cuarț neted",
  "block.minecraft.smooth_quartz_slab": "Lespede de cuarț neted",
  "block.minecraft.smooth_quartz_stairs": "Trepte de cuarț neted",
  "block.minecraft.smooth_red_sandstone": "Gresie roșie netedă",
  "block.minecraft.smooth_red_sandstone_slab": "Lespede de gresie roșie netedă",
  "block.minecraft.smooth_red_sandstone_stairs": "Trepte de gresie roșie netedă",
  "block.minecraft.smooth_sandstone": "Gresie netedă",
  "block.minecraft.smooth_sandstone_slab": "Lespede de gresie netedă",
  "block.minecraft.smooth_sandstone_stairs": "Trepte de gresie netedă",
  "block.minecraft.smooth_stone": "Piatră netedă",
  "block.minecraft.smooth_stone_slab": "Lespede de piatră netedă",
  "block.minecraft.sniffer_egg": "Ou de adulmecător",
  "block.minecraft.snow": "Zăpadă",
  "block.minecraft.snow_block": "Bloc de zăpadă",
  "block.minecraft.soul_campfire": "Foc de tabără de suflete",
  "block.minecraft.soul_fire": "Foc de suflete",
  "block.minecraft.soul_lantern": "Felinar de suflete",
  "block.minecraft.soul_sand": "Nisip de suflete",
  "block.minecraft.soul_soil": "Sol de suflete",
  "block.minecraft.soul_torch": "Torță de suflete",
  "block.minecraft.soul_wall_torch": "Torță de suflete pe perete",
  "block.minecraft.spawn.not_valid": "Nu ai un pat sau o ancoră de reînviere încărcată, sau a fost obstrucționată",
  "block.minecraft.spawner": "Generator de monștri",
  "block.minecraft.spawner.desc1": "Interacționează cu ouăle generatoare:",
  "block.minecraft.spawner.desc2": "Setează tipul de creatură",
  "block.minecraft.sponge": "Burete",
  "block.minecraft.spore_blossom": "Floare cu spori",
  "block.minecraft.spruce_button": "Buton de molid",
  "block.minecraft.spruce_door": "Ușă de molid",
  "block.minecraft.spruce_fence": "Gard de molid",
  "block.minecraft.spruce_fence_gate": "Portiță de molid",
  "block.minecraft.spruce_hanging_sign": "Semn agățat de molid",
  "block.minecraft.spruce_leaves": "Frunze de molid",
  "block.minecraft.spruce_log": "Buștean de molid",
  "block.minecraft.spruce_planks": "Scânduri de molid",
  "block.minecraft.spruce_pressure_plate": "Placă de presiune de molid",
  "block.minecraft.spruce_sapling": "Puiet de molid",
  "block.minecraft.spruce_shelf": "Raft de molid",
  "block.minecraft.spruce_sign": "Semn de molid",
  "block.minecraft.spruce_slab": "Lespede de molid",
  "block.minecraft.spruce_stairs": "Trepte de molid",
  "block.minecraft.spruce_trapdoor": "Trapă de molid",
  "block.minecraft.spruce_wall_hanging_sign": "Semn agățat de molid pe perete",
  "block.minecraft.spruce_wall_sign": "Semn de molid pe perete",
  "block.minecraft.spruce_wood": "Lemn de molid",
  "block.minecraft.sticky_piston": "Piston lipicios",
  "block.minecraft.stone": "Piatră",
  "block.minecraft.stone_brick_slab": "Lespede de cărămizi de piatră",
  "block.minecraft.stone_brick_stairs": "Trepte de cărămizi de piatră",
  "block.minecraft.stone_brick_wall": "Zid de cărămizi de piatră",
  "block.minecraft.stone_bricks": "Cărămizi de piatră",
  "block.minecraft.stone_button": "Buton de piatră",
  "block.minecraft.stone_pressure_plate": "Placă de presiune de piatră",
  "block.minecraft.stone_slab": "Lespede de piatră",
  "block.minecraft.stone_stairs": "Trepte de piatră",
  "block.minecraft.stonecutter": "Tăietor de piatră",
  "block.minecraft.stripped_acacia_log": "Buștean de salcâm decojit",
  "block.minecraft.stripped_acacia_wood": "Lemn de salcâm decojit",
  "block.minecraft.stripped_bamboo_block": "Bloc de bambus decojit",
  "block.minecraft.stripped_birch_log": "Buștean de mesteacăn decojit",
  "block.minecraft.stripped_birch_wood": "Lemn de mesteacăn decojit",
  "block.minecraft.stripped_cherry_log": "Buștean de cireș decojit",
  "block.minecraft.stripped_cherry_wood": "Lemn de cireș decojit",
  "block.minecraft.stripped_crimson_hyphae": "Hife stacojii decojite",
  "block.minecraft.stripped_crimson_stem": "Tulpină stacojie decojită",
  "block.minecraft.stripped_dark_oak_log": "Buștean de stejar negru decojit",
  "block.minecraft.stripped_dark_oak_wood": "Lemn de stejar negru decojit",
  "block.minecraft.stripped_jungle_log": "Buștean de junglă decojit",
  "block.minecraft.stripped_jungle_wood": "Lemn de junglă decojit",
  "block.minecraft.stripped_mangrove_log": "Buștean de mangrovă decojit",
  "block.minecraft.stripped_mangrove_wood": "Lemn de mangrovă decojit",
  "block.minecraft.stripped_oak_log": "Buștean de stejar decojit",
  "block.minecraft.stripped_oak_wood": "Lemn de stejar decojit",
  "block.minecraft.stripped_pale_oak_log": "Buștean de stejar palid decojit",
  "block.minecraft.stripped_pale_oak_wood": "Lemn de stejar palid decojit",
  "block.minecraft.stripped_spruce_log": "Buștean de molid decojit",
  "block.minecraft.stripped_spruce_wood": "Lemn de molid decojit",
  "block.minecraft.stripped_warped_hyphae": "Hife deformate decojite",
  "block.minecraft.stripped_warped_stem": "Tulpină deformată decojită",
  "block.minecraft.structure_block": "Bloc de structură",
  "block.minecraft.structure_void": "Vid de structură",
  "block.minecraft.sugar_cane": "Trestie de zahăr",
  "block.minecraft.sunflower": "Floarea-soarelui",
  "block.minecraft.suspicious_gravel": "Pietriș suspect",
  "block.minecraft.suspicious_sand": "Nisip suspect",
  "block.minecraft.sweet_berry_bush": "Tufă de fructe de pădure dulci",
  "block.minecraft.tall_dry_grass": "Iarbă mare uscată",
  "block.minecraft.tall_grass": "Iarbă înaltă",
  "block.minecraft.tall_seagrass": "Iarbă de mare înaltă",
  "block.minecraft.target": "Țintă",
  "block.minecraft.terracotta": "Teracotă",
  "block.minecraft.test_block": "Bloc de test",
  "block.minecraft.test_instance_block": "Bloc de test de instanță",
  "block.minecraft.tinted_glass": "Sticlă fumurie",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "Exploziile TNT sunt dezactivate",
  "block.minecraft.torch": "Torță",
  "block.minecraft.torchflower": "Floare-torță",
  "block.minecraft.torchflower_crop": "Cultură de floare-torță",
  "block.minecraft.trapped_chest": "Cufăr-capcană",
  "block.minecraft.trial_spawner": "Generator de încercări",
  "block.minecraft.tripwire": "Fir declanșator",
  "block.minecraft.tripwire_hook": "Cârlig pentru fir",
  "block.minecraft.tube_coral": "Coral tubular",
  "block.minecraft.tube_coral_block": "Bloc de coral tubular",
  "block.minecraft.tube_coral_fan": "Gorgonie tubulară",
  "block.minecraft.tube_coral_wall_fan": "Gorgonie tubulară pe perete",
  "block.minecraft.tuff": "Tuf",
  "block.minecraft.tuff_brick_slab": "Lespede de cărămizi de tuf",
  "block.minecraft.tuff_brick_stairs": "Trepte de cărămizi de tuf",
  "block.minecraft.tuff_brick_wall": "Zid de cărămizi de tuf",
  "block.minecraft.tuff_bricks": "Cărămizi de tuf",
  "block.minecraft.tuff_slab": "Lespede de tuf",
  "block.minecraft.tuff_stairs": "Trepte de tuf",
  "block.minecraft.tuff_wall": "Zid de tuf",
  "block.minecraft.turtle_egg": "Ou de țestoasă",
  "block.minecraft.twisting_vines": "Liane răsucite",
  "block.minecraft.twisting_vines_plant": "Plantă de liane răsucite",
  "block.minecraft.vault": "Seif",
  "block.minecraft.verdant_froglight": "Lumină de broască verde",
  "block.minecraft.vine": "Liane",
  "block.minecraft.void_air": "Aer de vid",
  "block.minecraft.wall_torch": "Torță pe perete",
  "block.minecraft.warped_button": "Buton deformat",
  "block.minecraft.warped_door": "Ușă deformată",
  "block.minecraft.warped_fence": "Gard deformat",
  "block.minecraft.warped_fence_gate": "Portiță deformată",
  "block.minecraft.warped_fungus": "Ciupercă deformată",
  "block.minecraft.warped_hanging_sign": "Semn agățat deformat",
  "block.minecraft.warped_hyphae": "Hife deformate",
  "block.minecraft.warped_nylium": "Niliu deformat",
  "block.minecraft.warped_planks": "Scânduri deformate",
  "block.minecraft.warped_pressure_plate": "Placă de presiune deformată",
  "block.minecraft.warped_roots": "Rădăcini deformate",
  "block.minecraft.warped_shelf": "Raft deformat",
  "block.minecraft.warped_sign": "Semn deformat",
  "block.minecraft.warped_slab": "Lespede deformată",
  "block.minecraft.warped_stairs": "Trepte deformate",
  "block.minecraft.warped_stem": "Tulpină deformată",
  "block.minecraft.warped_trapdoor": "Trapă deformată",
  "block.minecraft.warped_wall_hanging_sign": "Semn deformat agățat pe perete",
  "block.minecraft.warped_wall_sign": "Semn deformat pe perete",
  "block.minecraft.warped_wart_block": "Bloc de neg deformat",
  "block.minecraft.water": "Apă",
  "block.minecraft.water_cauldron": "Cazan cu apă",
  "block.minecraft.waxed_chiseled_copper": "Bloc de cupru sculptat ceruit",
  "block.minecraft.waxed_copper_bars": "Gratii de cupru ceruite",
  "block.minecraft.waxed_copper_block": "Bloc de cupru ceruit",
  "block.minecraft.waxed_copper_bulb": "Bec de cupru ceruit",
  "block.minecraft.waxed_copper_chain": "Lanț de cupru ceruit",
  "block.minecraft.waxed_copper_chest": "Cufăr de cupru ceruit",
  "block.minecraft.waxed_copper_door": "Ușă de cupru ceruită",
  "block.minecraft.waxed_copper_golem_statue": "Statuie de golem de cupru ceruit",
  "block.minecraft.waxed_copper_grate": "Grilă de cupru ceruit",
  "block.minecraft.waxed_copper_lantern": "Felinar de cupru ceruit",
  "block.minecraft.waxed_copper_trapdoor": "Trapă de cupru ceruită",
  "block.minecraft.waxed_cut_copper": "Bloc de cupru tăiat ceruit",
  "block.minecraft.waxed_cut_copper_slab": "Lespede de cupru tăiată ceruită",
  "block.minecraft.waxed_cut_copper_stairs": "Trepte de cupru tăiate ceruite",
  "block.minecraft.waxed_exposed_chiseled_copper": "Bloc de cupru sculptat expus ceruit",
  "block.minecraft.waxed_exposed_copper": "Bloc de cupru expus ceruit",
  "block.minecraft.waxed_exposed_copper_bars": "Gratii de cupru expuse ceruite",
  "block.minecraft.waxed_exposed_copper_bulb": "Bec de cupru expus ceruit",
  "block.minecraft.waxed_exposed_copper_chain": "Lanț de cupru expus ceruit",
  "block.minecraft.waxed_exposed_copper_chest": "Cufăr de cupru expus ceruit",
  "block.minecraft.waxed_exposed_copper_door": "Ușă de cupru expusă ceruită",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Statuie de golem de cupru expus ceruit",
  "block.minecraft.waxed_exposed_copper_grate": "Grilaj de cupru expus ceruit",
  "block.minecraft.waxed_exposed_copper_lantern": "Felinar de cupru expus ceruit",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Trapă de cupru expusă ceruită",
  "block.minecraft.waxed_exposed_cut_copper": "Bloc de cupru tăiat expus ceruit",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Lespede de cupru tăiată expusă ceruită",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Trepte de cupru tăiate expuse ceruite",
  "block.minecraft.waxed_exposed_lightning_rod": "Paratrăsnet expus ceruit",
  "block.minecraft.waxed_lightning_rod": "Paratrăsnet ceruit",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Bloc de cupru sculptat oxidat ceruit",
  "block.minecraft.waxed_oxidized_copper": "Bloc de cupru oxidat ceruit",
  "block.minecraft.waxed_oxidized_copper_bars": "Gratii de cupru oxidate ceruite",
  "block.minecraft.waxed_oxidized_copper_bulb": "Bec de cupru oxidat ceruit",
  "block.minecraft.waxed_oxidized_copper_chain": "Lanț de cupru oxidat ceruit",
  "block.minecraft.waxed_oxidized_copper_chest": "Cufăr de cupru oxidat ceruit",
  "block.minecraft.waxed_oxidized_copper_door": "Ușă de cupru oxidată ceruită",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Statuie de golem de cupru oxidat ceruit",
  "block.minecraft.waxed_oxidized_copper_grate": "Grilaj de cupru oxidat ceruit",
  "block.minecraft.waxed_oxidized_copper_lantern": "Felinar de cupru oxidat ceruit",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Trapă de cupru oxidată ceruită",
  "block.minecraft.waxed_oxidized_cut_copper": "Bloc de cupru tăiat oxidat ceruit",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Lespede de cupru tăiată oxidată ceruită",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Trepte de cupru tăiate oxidate ceruite",
  "block.minecraft.waxed_oxidized_lightning_rod": "Paratrăsnet oxidat ceruit",
  "block.minecraft.waxed_weathered_chiseled_copper": "Bloc de cupru sculptat erodat ceruit",
  "block.minecraft.waxed_weathered_copper": "Bloc de cupru erodat ceruit",
  "block.minecraft.waxed_weathered_copper_bars": "Gratii de cupru erodate ceruite",
  "block.minecraft.waxed_weathered_copper_bulb": "Bec de cupru erodat ceruit",
  "block.minecraft.waxed_weathered_copper_chain": "Lanț de cupru erodat ceruit",
  "block.minecraft.waxed_weathered_copper_chest": "Cufăr de cupru erodat ceruit",
  "block.minecraft.waxed_weathered_copper_door": "Ușă de cupru erodată ceruită",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Statuie de golem de cupru erodat ceruit",
  "block.minecraft.waxed_weathered_copper_grate": "Grilaj de cupru erodat ceruit",
  "block.minecraft.waxed_weathered_copper_lantern": "Felinar de cupru erodat ceruit",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Trapă de cupru erodată ceruită",
  "block.minecraft.waxed_weathered_cut_copper": "Bloc de cupru tăiat erodat ceruit",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Lespede de cupru tăiată erodată ceruită",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Trepte de cupru tăiate erodate ceruite",
  "block.minecraft.waxed_weathered_lightning_rod": "Paratrăsnet erodat ceruit",
  "block.minecraft.weathered_chiseled_copper": "Bloc de cupru sculptat erodat",
  "block.minecraft.weathered_copper": "Bloc de cupru erodat",
  "block.minecraft.weathered_copper_bars": "Gratii de cupru erodate",
  "block.minecraft.weathered_copper_bulb": "Bec de cupru erodat",
  "block.minecraft.weathered_copper_chain": "Lanț de cupru erodat",
  "block.minecraft.weathered_copper_chest": "Cufăr de cupru erodat",
  "block.minecraft.weathered_copper_door": "Ușă de cupru erodată",
  "block.minecraft.weathered_copper_golem_statue": "Statuie de golem de cupru erodat",
  "block.minecraft.weathered_copper_grate": "Grilaj de cupru erodat",
  "block.minecraft.weathered_copper_lantern": "Felinar de cupru erodat",
  "block.minecraft.weathered_copper_trapdoor": "Trapă de cupru erodată",
  "block.minecraft.weathered_cut_copper": "Bloc de cupru tăiat erodat",
  "block.minecraft.weathered_cut_copper_slab": "Lespede de cupru tăiată erodată",
  "block.minecraft.weathered_cut_copper_stairs": "Trepte de cupru tăiate erodate",
  "block.minecraft.weathered_lightning_rod": "Paratrăsnet erodat",
  "block.minecraft.weeping_vines": "Liane plângătoare",
  "block.minecraft.weeping_vines_plant": "Plantă de liane plângătoare",
  "block.minecraft.wet_sponge": "Burete ud",
  "block.minecraft.wheat": "Grâu",
  "block.minecraft.white_banner": "Stindard alb",
  "block.minecraft.white_bed": "Pat alb",
  "block.minecraft.white_candle": "Lumânare albă",
  "block.minecraft.white_candle_cake": "Tort cu lumânare albă",
  "block.minecraft.white_carpet": "Covor alb",
  "block.minecraft.white_concrete": "Beton alb",
  "block.minecraft.white_concrete_powder": "Beton uscat alb",
  "block.minecraft.white_glazed_terracotta": "Teracotă smălțuită albă",
  "block.minecraft.white_shulker_box": "Cutie de shulker albă",
  "block.minecraft.white_stained_glass": "Sticlă albă",
  "block.minecraft.white_stained_glass_pane": "Geam alb",
  "block.minecraft.white_terracotta": "Teracotă albă",
  "block.minecraft.white_tulip": "Lalea albă",
  "block.minecraft.white_wool": "Lână albă",
  "block.minecraft.wildflowers": "Flori de câmp",
  "block.minecraft.wither_rose": "Trandafir al witherului",
  "block.minecraft.wither_skeleton_skull": "Craniu de schelet wither",
  "block.minecraft.wither_skeleton_wall_skull": "Craniu de schelet wither pe perete",
  "block.minecraft.yellow_banner": "Stindard galben",
  "block.minecraft.yellow_bed": "Pat galben",
  "block.minecraft.yellow_candle": "Lumânare galbenă",
  "block.minecraft.yellow_candle_cake": "Tort cu lumânare galbenă",
  "block.minecraft.yellow_carpet": "Covor galben",
  "block.minecraft.yellow_concrete": "Beton galben",
  "block.minecraft.yellow_concrete_powder": "Beton uscat galben",
  "block.minecraft.yellow_glazed_terracotta": "Teracotă smălțuită galbenă",
  "block.minecraft.yellow_shulker_box": "Cutie de shulker galbenă",
  "block.minecraft.yellow_stained_glass": "Sticlă galbenă",
  "block.minecraft.yellow_stained_glass_pane": "Geam galben",
  "block.minecraft.yellow_terracotta": "Teracotă galbenă",
  "block.minecraft.yellow_wool": "Lână galbenă",
  "block.minecraft.zombie_head": "Cap de zombi",
  "block.minecraft.zombie_wall_head": "Cap de zombi pe perete",
  "item.minecraft.acacia_boat": "Barcă de salcâm",
  "item.minecraft.acacia_chest_boat": "Barcă de salcâm cu cufăr",
  "item.minecraft.allay_spawn_egg": "Ou generator de aliat",
  "item.minecraft.amethyst_shard": "Ciob de ametist",
  "item.minecraft.angler_pottery_shard": "Ciob de ceramică de pescar",
  "item.minecraft.angler_pottery_sherd": "Ciob de ceramică de pescar",
  "item.minecraft.apple": "Măr",
  "item.minecraft.archer_pottery_shard": "Ciob de ceramică de arcaș",
  "item.minecraft.archer_pottery_sherd": "Ciob de ceramică de arcaș",
  "item.minecraft.armadillo_scute": "Solz de tatu",
  "item.minecraft.armadillo_spawn_egg": "Ou generator de tatu",
  "item.minecraft.armor_stand": "Suport de armură",
  "item.minecraft.arms_up_pottery_shard": "Ciob de ceramică de figură",
  "item.minecraft.arms_up_pottery_sherd": "Ciob de ceramică de figură",
  "item.minecraft.arrow": "Săgeată",
  "item.minecraft.axolotl_bucket": "Găleată cu axolot",
  "item.minecraft.axolotl_spawn_egg": "Ou generator de axolot",
  "item.minecraft.baked_potato": "Cartof copt",
  "item.minecraft.bamboo_chest_raft": "Plută de bambus cu cufăr",
  "item.minecraft.bamboo_raft": "Plută de bambus",
  "item.minecraft.bat_spawn_egg": "Ou generator de liliac",
  "item.minecraft.bee_spawn_egg": "Ou generator de albină",
  "item.minecraft.beef": "Carne de vită crudă",
  "item.minecraft.beetroot": "Sfeclă",
  "item.minecraft.beetroot_seeds": "Semințe de sfeclă",
  "item.minecraft.beetroot_soup": "Supă de sfeclă",
  "item.minecraft.birch_boat": "Barcă de mesteacăn",
  "item.minecraft.birch_chest_boat": "Barca de mesteacăn cu cufăr",
  "item.minecraft.black_bundle": "Săculeț negru",
  "item.minecraft.black_dye": "Colorant negru",
  "item.minecraft.black_harness": "Ham negru",
  "item.minecraft.blade_pottery_shard": "Ciob de ceramică de lamă",
  "item.minecraft.blade_pottery_sherd": "Ciob de ceramică de lamă",
  "item.minecraft.blaze_powder": "Pulbere dogoritoare",
  "item.minecraft.blaze_rod": "Tijă dogoritoare",
  "item.minecraft.blaze_spawn_egg": "Ou generator de dogoreală",
  "item.minecraft.blue_bundle": "Săculeț albastru",
  "item.minecraft.blue_dye": "Colorant albastru",
  "item.minecraft.blue_egg": "Ou albastru",
  "item.minecraft.blue_harness": "Ham albastru",
  "item.minecraft.bogged_spawn_egg": "Ou generator de împotmolit",
  "item.minecraft.bolt_armor_trim_smithing_template": "Șablon de fierărie",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Ornament de armură de bolț",
  "item.minecraft.bone": "Os",
  "item.minecraft.bone_meal": "Făină de oase",
  "item.minecraft.book": "Carte",
  "item.minecraft.bordure_indented_banner_pattern": "Model pentru stindard de bordură dințată",
  "item.minecraft.bow": "Arc",
  "item.minecraft.bowl": "Bol",
  "item.minecraft.bread": "Pâine",
  "item.minecraft.breeze_rod": "Tijă de briză",
  "item.minecraft.breeze_spawn_egg": "Ou generator de briză",
  "item.minecraft.brewer_pottery_shard": "Ciob de ceramică de alchimist",
  "item.minecraft.brewer_pottery_sherd": "Ciob de ceramică de alchimist",
  "item.minecraft.brewing_stand": "Alambic",
  "item.minecraft.brick": "Cărămidă",
  "item.minecraft.brown_bundle": "Săculeț maro",
  "item.minecraft.brown_dye": "Colorant maro",
  "item.minecraft.brown_egg": "Ou maro",
  "item.minecraft.brown_harness": "Ham maro",
  "item.minecraft.brush": "Perie",
  "item.minecraft.bucket": "Găleată",
  "item.minecraft.bundle": "Săculeț",
  "item.minecraft.bundle.empty": "Gol",
  "item.minecraft.bundle.empty.description": "Poate conține o stivă mixtă de obiecte",
  "item.minecraft.bundle.full": "Plin",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Ciob de ceramică de foc",
  "item.minecraft.burn_pottery_sherd": "Ciob de ceramică de foc",
  "item.minecraft.camel_husk_spawn_egg": "Ou generator de cămilă-momâie",
  "item.minecraft.camel_spawn_egg": "Ou generator de cămilă",
  "item.minecraft.carrot": "Morcov",
  "item.minecraft.carrot_on_a_stick": "Morcov pe un băț",
  "item.minecraft.cat_spawn_egg": "Ou generator de pisică",
  "item.minecraft.cauldron": "Cazan",
  "item.minecraft.cave_spider_spawn_egg": "Ou generator de păianjen de peșteră",
  "item.minecraft.chainmail_boots": "Cizme de zale",
  "item.minecraft.chainmail_chestplate": "Platoșă de zale",
  "item.minecraft.chainmail_helmet": "Cască de zale",
  "item.minecraft.chainmail_leggings": "Jambiere de zale",
  "item.minecraft.charcoal": "Cărbune de lemn",
  "item.minecraft.cherry_boat": "Barcă de cireș",
  "item.minecraft.cherry_chest_boat": "Barcă de cireș cu cufăr",
  "item.minecraft.chest_minecart": "Vagonet cu cufăr",
  "item.minecraft.chicken": "Pui crud",
  "item.minecraft.chicken_spawn_egg": "Ou generator de găină",
  "item.minecraft.chorus_fruit": "Fruct coral",
  "item.minecraft.clay_ball": "Bulgăre de lut",
  "item.minecraft.clock": "Ceas",
  "item.minecraft.coal": "Cărbune",
  "item.minecraft.coast_armor_trim_smithing_template": "Șablon de fierărie",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Ornament de armură de litoral",
  "item.minecraft.cocoa_beans": "Boabe de cacao",
  "item.minecraft.cod": "Cod crud",
  "item.minecraft.cod_bucket": "Găleată cu cod",
  "item.minecraft.cod_spawn_egg": "Ou generator de cod",
  "item.minecraft.command_block_minecart": "Vagonet cu bloc de comenzi",
  "item.minecraft.compass": "Busolă",
  "item.minecraft.cooked_beef": "Carne de vită friptă",
  "item.minecraft.cooked_chicken": "Pui fript",
  "item.minecraft.cooked_cod": "Cod fript",
  "item.minecraft.cooked_mutton": "Carne de oaie friptă",
  "item.minecraft.cooked_porkchop": "Carne de porc friptă",
  "item.minecraft.cooked_rabbit": "Iepure fript",
  "item.minecraft.cooked_salmon": "Somon fript",
  "item.minecraft.cookie": "Fursec",
  "item.minecraft.copper_axe": "Topor de cupru",
  "item.minecraft.copper_boots": "Cizme de cupru",
  "item.minecraft.copper_chestplate": "Platoșă de cupru",
  "item.minecraft.copper_golem_spawn_egg": "Ou generator de golem de cupru",
  "item.minecraft.copper_helmet": "Cască de cupru",
  "item.minecraft.copper_hoe": "Sapă de cupru",
  "item.minecraft.copper_horse_armor": "Armură de cal din cupru",
  "item.minecraft.copper_ingot": "Lingou de cupru",
  "item.minecraft.copper_leggings": "Jambiere de cupru",
  "item.minecraft.copper_nautilus_armor": "Armură de nautil din cupru",
  "item.minecraft.copper_nugget": "Pepită de cupru",
  "item.minecraft.copper_pickaxe": "Târnăcop de cupru",
  "item.minecraft.copper_shovel": "Lopată de cupru",
  "item.minecraft.copper_spear": "Suliță de cupru",
  "item.minecraft.copper_sword": "Sabie de cupru",
  "item.minecraft.cow_spawn_egg": "Ou generator de vacă",
  "item.minecraft.creaking_spawn_egg": "Ou generator de scârțâitor",
  "item.minecraft.creeper_banner_pattern": "Model pentru stindard",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Model pentru stindard de creeper",
  "item.minecraft.creeper_spawn_egg": "Ou generator de creeper",
  "item.minecraft.crossbow": "Arbaletă",
  "item.minecraft.crossbow.projectile": "Proiectil:",
  "item.minecraft.crossbow.projectile.multiple": "Proiectil: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Proiectil: %s",
  "item.minecraft.cyan_bundle": "Săculeț turcoaz",
  "item.minecraft.cyan_dye": "Colorant turcoaz",
  "item.minecraft.cyan_harness": "Ham turcoaz",
  "item.minecraft.danger_pottery_shard": "Ciob de ceramică de pericol",
  "item.minecraft.danger_pottery_sherd": "Ciob de ceramică de pericol",
  "item.minecraft.dark_oak_boat": "Barcă de stejar negru",
  "item.minecraft.dark_oak_chest_boat": "Barcă de stejar negru cu cufăr",
  "item.minecraft.debug_stick": "Băț de depanare",
  "item.minecraft.debug_stick.empty": "%s nu are nicio proprietate",
  "item.minecraft.debug_stick.select": "\"%s\" selectat (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" schimbat în %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Topor de diamant",
  "item.minecraft.diamond_boots": "Cizme de diamant",
  "item.minecraft.diamond_chestplate": "Platoșă de diamant",
  "item.minecraft.diamond_helmet": "Cască de diamant",
  "item.minecraft.diamond_hoe": "Sapă de diamant",
  "item.minecraft.diamond_horse_armor": "Armură de cal din diamant",
  "item.minecraft.diamond_leggings": "Jambiere de diamant",
  "item.minecraft.diamond_nautilus_armor": "Armură de nautil din diamant",
  "item.minecraft.diamond_pickaxe": "Târnăcop de diamant",
  "item.minecraft.diamond_shovel": "Lopată de diamant",
  "item.minecraft.diamond_spear": "Suliță de diamant",
  "item.minecraft.diamond_sword": "Sabie de diamant",
  "item.minecraft.disc_fragment_5": "Fragmente de disc",
  "item.minecraft.disc_fragment_5.desc": "Disc muzical — 5",
  "item.minecraft.dolphin_spawn_egg": "Ou generator de delfin",
  "item.minecraft.donkey_spawn_egg": "Ou generator de măgar",
  "item.minecraft.dragon_breath": "Suflu de dragon",
  "item.minecraft.dried_kelp": "Algă uscată",
  "item.minecraft.drowned_spawn_egg": "Ou generator de înecat",
  "item.minecraft.dune_armor_trim_smithing_template": "Șablon de fierărie",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Ornament de armură de dună",
  "item.minecraft.echo_shard": "Ciob de ecou",
  "item.minecraft.egg": "Ou",
  "item.minecraft.elder_guardian_spawn_egg": "Ou generator de mare străjer",
  "item.minecraft.elytra": "Elitre",
  "item.minecraft.emerald": "Smarald",
  "item.minecraft.enchanted_book": "Carte fermecată",
  "item.minecraft.enchanted_golden_apple": "Măr de aur fermecat",
  "item.minecraft.end_crystal": "Cristal din End",
  "item.minecraft.ender_dragon_spawn_egg": "Ou generator de dragon de Ender",
  "item.minecraft.ender_eye": "Ochi de Ender",
  "item.minecraft.ender_pearl": "Perlă de Ender",
  "item.minecraft.enderman_spawn_egg": "Ou generator de enderman",
  "item.minecraft.endermite_spawn_egg": "Ou generator de endermit",
  "item.minecraft.evoker_spawn_egg": "Ou generator de evocator",
  "item.minecraft.experience_bottle": "Sticluță de experiență",
  "item.minecraft.explorer_pottery_shard": "Ciob de ceramică de explorator",
  "item.minecraft.explorer_pottery_sherd": "Ciob de ceramică de explorator",
  "item.minecraft.eye_armor_trim_smithing_template": "Șablon de fierărie",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Ornament de armură de ochi",
  "item.minecraft.feather": "Pană",
  "item.minecraft.fermented_spider_eye": "Ochi de păianjen fermentat",
  "item.minecraft.field_masoned_banner_pattern": "Model pentru stindard de câmp zidit",
  "item.minecraft.filled_map": "Hartă",
  "item.minecraft.fire_charge": "Minge de foc",
  "item.minecraft.firework_rocket": "Artificiu",
  "item.minecraft.firework_rocket.flight": "Durata zborului:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Stea de artificiu",
  "item.minecraft.firework_star.black": "Negru",
  "item.minecraft.firework_star.blue": "Albastru",
  "item.minecraft.firework_star.brown": "Maro",
  "item.minecraft.firework_star.custom_color": "Personalizat",
  "item.minecraft.firework_star.cyan": "Turcoaz",
  "item.minecraft.firework_star.fade_to": "Trecere spre",
  "item.minecraft.firework_star.flicker": "Sclipire",
  "item.minecraft.firework_star.gray": "Gri",
  "item.minecraft.firework_star.green": "Verde",
  "item.minecraft.firework_star.light_blue": "Bleu",
  "item.minecraft.firework_star.light_gray": "Gri-deschis",
  "item.minecraft.firework_star.lime": "Verde-deschis",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Portocaliu",
  "item.minecraft.firework_star.pink": "Roz",
  "item.minecraft.firework_star.purple": "Violet",
  "item.minecraft.firework_star.red": "Roșu",
  "item.minecraft.firework_star.shape": "Formă necunoscută",
  "item.minecraft.firework_star.shape.burst": "Spargere",
  "item.minecraft.firework_star.shape.creeper": "În formă de creeper",
  "item.minecraft.firework_star.shape.large_ball": "Sferă mare",
  "item.minecraft.firework_star.shape.small_ball": "Sferă mică",
  "item.minecraft.firework_star.shape.star": "În formă de stea",
  "item.minecraft.firework_star.trail": "Dâră",
  "item.minecraft.firework_star.white": "Alb",
  "item.minecraft.firework_star.yellow": "Galben",
  "item.minecraft.fishing_rod": "Undiță",
  "item.minecraft.flint": "Cremene",
  "item.minecraft.flint_and_steel": "Cremene și amnar",
  "item.minecraft.flow_armor_trim_smithing_template": "Șablon de fierărie",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Ornament de armură de spirală",
  "item.minecraft.flow_banner_pattern": "Model pentru stindard",
  "item.minecraft.flow_banner_pattern.desc": "Spirală",
  "item.minecraft.flow_banner_pattern.new": "Model pentru stindard de spirală",
  "item.minecraft.flow_pottery_sherd": "Ciob de ceramică de spirală",
  "item.minecraft.flower_banner_pattern": "Model pentru stindard",
  "item.minecraft.flower_banner_pattern.desc": "Floare",
  "item.minecraft.flower_banner_pattern.new": "Model pentru stindard de floare",
  "item.minecraft.flower_pot": "Ghiveci de flori",
  "item.minecraft.fox_spawn_egg": "Ou generator de vulpe",
  "item.minecraft.friend_pottery_shard": "Ciob de ceramică de prieten",
  "item.minecraft.friend_pottery_sherd": "Ciob de ceramică de prieten",
  "item.minecraft.frog_spawn_egg": "Ou generator de broască",
  "item.minecraft.furnace_minecart": "Vagonet cu cuptor",
  "item.minecraft.ghast_spawn_egg": "Ou generator de ghast",
  "item.minecraft.ghast_tear": "Lacrimă de ghast",
  "item.minecraft.glass_bottle": "Sticluță goală",
  "item.minecraft.glistering_melon_slice": "Felie de pepene strălucitoare",
  "item.minecraft.globe_banner_pattern": "Model pentru stindard",
  "item.minecraft.globe_banner_pattern.desc": "Glob",
  "item.minecraft.globe_banner_pattern.new": "Model pentru stindard de glob",
  "item.minecraft.glow_berries": "Fructe de pădure strălucitoare",
  "item.minecraft.glow_ink_sac": "Pungă de cerneală strălucitoare",
  "item.minecraft.glow_item_frame": "Ramă strălucitoare de obiecte",
  "item.minecraft.glow_squid_spawn_egg": "Ou generator de calamar strălucitor",
  "item.minecraft.glowstone_dust": "Praf strălucitor",
  "item.minecraft.goat_horn": "Corn de capră",
  "item.minecraft.goat_spawn_egg": "Ou generator de capră",
  "item.minecraft.gold_ingot": "Lingou de aur",
  "item.minecraft.gold_nugget": "Pepită de aur",
  "item.minecraft.golden_apple": "Măr de aur",
  "item.minecraft.golden_axe": "Topor de aur",
  "item.minecraft.golden_boots": "Cizme de aur",
  "item.minecraft.golden_carrot": "Morcov de aur",
  "item.minecraft.golden_chestplate": "Platoșă de aur",
  "item.minecraft.golden_helmet": "Cască de aur",
  "item.minecraft.golden_hoe": "Sapă de aur",
  "item.minecraft.golden_horse_armor": "Armură de cal din aur",
  "item.minecraft.golden_leggings": "Jambiere de aur",
  "item.minecraft.golden_nautilus_armor": "Armură de nautil din aur",
  "item.minecraft.golden_pickaxe": "Târnăcop de aur",
  "item.minecraft.golden_shovel": "Lopată de aur",
  "item.minecraft.golden_spear": "Suliță de aur",
  "item.minecraft.golden_sword": "Sabie de aur",
  "item.minecraft.gray_bundle": "Săculeț gri",
  "item.minecraft.gray_dye": "Colorant gri",
  "item.minecraft.gray_harness": "Ham gri",
  "item.minecraft.green_bundle": "Săculeț verde",
  "item.minecraft.green_dye": "Colorant verde",
  "item.minecraft.green_harness": "Ham verde",
  "item.minecraft.guardian_spawn_egg": "Ou generator de străjer",
  "item.minecraft.gunpowder": "Praf de pușcă",
  "item.minecraft.guster_banner_pattern": "Model pentru stindard",
  "item.minecraft.guster_banner_pattern.desc": "Rafală",
  "item.minecraft.guster_banner_pattern.new": "Model pentru stindard de rafală",
  "item.minecraft.guster_pottery_sherd": "Ciob de ceramică de rafală",
  "item.minecraft.happy_ghast_spawn_egg": "Ou generator de ghast fericit",
  "item.minecraft.harness": "Ham",
  "item.minecraft.heart_of_the_sea": "Inima mării",
  "item.minecraft.heart_pottery_shard": "Ciob de ceramică de inimă",
  "item.minecraft.heart_pottery_sherd": "Ciob de ceramică de inimă",
  "item.minecraft.heartbreak_pottery_shard": "Ciob de ceramică de inimă frântă",
  "item.minecraft.heartbreak_pottery_sherd": "Ciob de ceramică de inimă frântă",
  "item.minecraft.hoglin_spawn_egg": "Ou generator de hoglin",
  "item.minecraft.honey_bottle": "Sticlă cu miere",
  "item.minecraft.honeycomb": "Fagure",
  "item.minecraft.hopper_minecart": "Vagonet cu pâlnie",
  "item.minecraft.horse_spawn_egg": "Ou generator de cal",
  "item.minecraft.host_armor_trim_smithing_template": "Șablon de fierărie",
  "item.minecraft.host_armor_trim_smithing_template.new": "Ornament de armură de gazdă",
  "item.minecraft.howl_pottery_shard": "Ciob de ceramică de lup",
  "item.minecraft.howl_pottery_sherd": "Ciob de ceramică de lup",
  "item.minecraft.husk_spawn_egg": "Ou generator de momâie",
  "item.minecraft.ink_sac": "Pungă de cerneală",
  "item.minecraft.iron_axe": "Topor de fier",
  "item.minecraft.iron_boots": "Cizme de fier",
  "item.minecraft.iron_chestplate": "Platoșă de fier",
  "item.minecraft.iron_golem_spawn_egg": "Ou generator de golem de fier",
  "item.minecraft.iron_helmet": "Cască de fier",
  "item.minecraft.iron_hoe": "Sapă de fier",
  "item.minecraft.iron_horse_armor": "Armură de cal din fier",
  "item.minecraft.iron_ingot": "Lingou de fier",
  "item.minecraft.iron_leggings": "Jambiere de fier",
  "item.minecraft.iron_nautilus_armor": "Armură de nautil din fier",
  "item.minecraft.iron_nugget": "Pepită de fier",
  "item.minecraft.iron_pickaxe": "Târnăcop de fier",
  "item.minecraft.iron_shovel": "Lopată de fier",
  "item.minecraft.iron_spear": "Suliță de fier",
  "item.minecraft.iron_sword": "Sabie de fier",
  "item.minecraft.item_frame": "Ramă de obiect",
  "item.minecraft.jungle_boat": "Barcă de junglă",
  "item.minecraft.jungle_chest_boat": "Barcă de junglă cu cufăr",
  "item.minecraft.knowledge_book": "Carte de cunoaștere",
  "item.minecraft.lapis_lazuli": "Lapislazuli",
  "item.minecraft.lava_bucket": "Găleată cu lavă",
  "item.minecraft.lead": "Lesă",
  "item.minecraft.leather": "Piele",
  "item.minecraft.leather_boots": "Cizme de piele",
  "item.minecraft.leather_chestplate": "Tunică de piele",
  "item.minecraft.leather_helmet": "Cască de piele",
  "item.minecraft.leather_horse_armor": "Armură de cal din piele",
  "item.minecraft.leather_leggings": "Pantaloni de piele",
  "item.minecraft.light_blue_bundle": "Săculeț bleu",
  "item.minecraft.light_blue_dye": "Colorant bleu",
  "item.minecraft.light_blue_harness": "Ham bleu",
  "item.minecraft.light_gray_bundle": "Săculeț gri-deschis",
  "item.minecraft.light_gray_dye": "Colorant gri-deschis",
  "item.minecraft.light_gray_harness": "Ham gri-deschis",
  "item.minecraft.lime_bundle": "Săculeț verde-deschis",
  "item.minecraft.lime_dye": "Colorant verde-deschis",
  "item.minecraft.lime_harness": "Ham verde-deschis",
  "item.minecraft.lingering_potion": "Poțiune persistentă",
  "item.minecraft.lingering_potion.effect.awkward": "Poțiune stingheră persistentă",
  "item.minecraft.lingering_potion.effect.empty": "Poțiune persistentă nefabricabilă",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Poțiune de rezistență la foc persistentă",
  "item.minecraft.lingering_potion.effect.harming": "Poțiune de vătămare persistentă",
  "item.minecraft.lingering_potion.effect.healing": "Poțiune de vindecare persistentă",
  "item.minecraft.lingering_potion.effect.infested": "Poțiune de infestare persistentă",
  "item.minecraft.lingering_potion.effect.invisibility": "Poțiune de invizibilitate persistentă",
  "item.minecraft.lingering_potion.effect.leaping": "Poțiune de sărit persistentă",
  "item.minecraft.lingering_potion.effect.levitation": "Poțiune de levitație persistentă",
  "item.minecraft.lingering_potion.effect.luck": "Poțiune de noroc persistentă",
  "item.minecraft.lingering_potion.effect.mundane": "Poțiune banală persistentă",
  "item.minecraft.lingering_potion.effect.night_vision": "Poțiune de vedere nocturnă persistentă",
  "item.minecraft.lingering_potion.effect.oozing": "Poțiune de înmâzgare persistentă",
  "item.minecraft.lingering_potion.effect.poison": "Poțiune de otravă persistentă",
  "item.minecraft.lingering_potion.effect.regeneration": "Poțiune de regenerare persistentă",
  "item.minecraft.lingering_potion.effect.slow_falling": "Poțiune de cădere lentă persistentă",
  "item.minecraft.lingering_potion.effect.slowness": "Poțiune de încetineală persistentă",
  "item.minecraft.lingering_potion.effect.strength": "Poțiune de forță persistentă",
  "item.minecraft.lingering_potion.effect.swiftness": "Poțiune de viteză persistentă",
  "item.minecraft.lingering_potion.effect.thick": "Poțiune groasă persistentă",
  "item.minecraft.lingering_potion.effect.turtle_master": "Poțiune a maestrului țestoaselor persistentă",
  "item.minecraft.lingering_potion.effect.water": "Sticluță cu apă persistentă",
  "item.minecraft.lingering_potion.effect.water_breathing": "Poțiune de respirație subacvatică persistentă",
  "item.minecraft.lingering_potion.effect.weakness": "Poțiune de slăbiciune persistentă",
  "item.minecraft.lingering_potion.effect.weaving": "Poțiune de țesere persistentă",
  "item.minecraft.lingering_potion.effect.wind_charged": "Poțiune de încărcătura vântului persistentă",
  "item.minecraft.llama_spawn_egg": "Ou generator de lamă",
  "item.minecraft.lodestone_compass": "Busolă magnetizată",
  "item.minecraft.mace": "Buzdugan",
  "item.minecraft.magenta_bundle": "Săculeț magenta",
  "item.minecraft.magenta_dye": "Colorant magenta",
  "item.minecraft.magenta_harness": "Ham magenta",
  "item.minecraft.magma_cream": "Cremă de magmă",
  "item.minecraft.magma_cube_spawn_egg": "Ou generator de cub de magmă",
  "item.minecraft.mangrove_boat": "Barcă de mangrovă",
  "item.minecraft.mangrove_chest_boat": "Barcă de mangrovă cu cufăr",
  "item.minecraft.map": "Hartă goală",
  "item.minecraft.melon_seeds": "Semințe de pepene",
  "item.minecraft.melon_slice": "Felie de pepene",
  "item.minecraft.milk_bucket": "Găleată cu lapte",
  "item.minecraft.minecart": "Vagonet",
  "item.minecraft.miner_pottery_shard": "Ciob de ceramică de miner",
  "item.minecraft.miner_pottery_sherd": "Ciob de ceramică de miner",
  "item.minecraft.mojang_banner_pattern": "Model pentru stindard",
  "item.minecraft.mojang_banner_pattern.desc": "Chestie",
  "item.minecraft.mojang_banner_pattern.new": "Model pentru stindard de lucru",
  "item.minecraft.mooshroom_spawn_egg": "Ou generator de mooshroom",
  "item.minecraft.mourner_pottery_shard": "Ciob de ceramică de jelitor",
  "item.minecraft.mourner_pottery_sherd": "Ciob de ceramică de jelitor",
  "item.minecraft.mule_spawn_egg": "Ou generator de catâr",
  "item.minecraft.mushroom_stew": "Supă de ciuperci",
  "item.minecraft.music_disc_11": "Disc muzical",
  "item.minecraft.music_disc_11.desc": "C418 — 11",
  "item.minecraft.music_disc_13": "Disc muzical",
  "item.minecraft.music_disc_13.desc": "C418 — 13",
  "item.minecraft.music_disc_5": "Disc muzical",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg — 5",
  "item.minecraft.music_disc_blocks": "Disc muzical",
  "item.minecraft.music_disc_blocks.desc": "C418 — blocks",
  "item.minecraft.music_disc_cat": "Disc muzical",
  "item.minecraft.music_disc_cat.desc": "C418 — cat",
  "item.minecraft.music_disc_chirp": "Disc muzical",
  "item.minecraft.music_disc_chirp.desc": "C418 — chirp",
  "item.minecraft.music_disc_creator": "Disc muzical",
  "item.minecraft.music_disc_creator.desc": "Lena Raine — Creator",
  "item.minecraft.music_disc_creator_music_box": "Disc muzical",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine — Creator (cutie muzicală)",
  "item.minecraft.music_disc_far": "Disc muzical",
  "item.minecraft.music_disc_far.desc": "C418 — far",
  "item.minecraft.music_disc_lava_chicken": "Disc muzical",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions — Lava Chicken",
  "item.minecraft.music_disc_mall": "Disc muzical",
  "item.minecraft.music_disc_mall.desc": "C418 — mall",
  "item.minecraft.music_disc_mellohi": "Disc muzical",
  "item.minecraft.music_disc_mellohi.desc": "C418 — mellohi",
  "item.minecraft.music_disc_otherside": "Disc muzical",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine — otherside",
  "item.minecraft.music_disc_pigstep": "Disc muzical",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine — Pigstep",
  "item.minecraft.music_disc_precipice": "Disc muzical",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof — Precipice",
  "item.minecraft.music_disc_relic": "Disc muzical",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof — Relic",
  "item.minecraft.music_disc_stal": "Disc muzical",
  "item.minecraft.music_disc_stal.desc": "C418 — stal",
  "item.minecraft.music_disc_strad": "Disc muzical",
  "item.minecraft.music_disc_strad.desc": "C418 — strad",
  "item.minecraft.music_disc_tears": "Disc muzical",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy — Tears",
  "item.minecraft.music_disc_wait": "Disc muzical",
  "item.minecraft.music_disc_wait.desc": "C418 — wait",
  "item.minecraft.music_disc_ward": "Disc muzical",
  "item.minecraft.music_disc_ward.desc": "C418 — ward",
  "item.minecraft.mutton": "Carne de oaie crudă",
  "item.minecraft.name_tag": "Etichetă de nume",
  "item.minecraft.nautilus_shell": "Cochilie de nautil",
  "item.minecraft.nautilus_spawn_egg": "Ou generator de nautil",
  "item.minecraft.nether_brick": "Cărămidă de Nether",
  "item.minecraft.nether_star": "Stea de Nether",
  "item.minecraft.nether_wart": "Neg din Nether",
  "item.minecraft.netherite_axe": "Topor de netherit",
  "item.minecraft.netherite_boots": "Cizme de netherit",
  "item.minecraft.netherite_chestplate": "Platoșă de netherit",
  "item.minecraft.netherite_helmet": "Cască de netherit",
  "item.minecraft.netherite_hoe": "Sapă de netherit",
  "item.minecraft.netherite_horse_armor": "Armură de cal de netherit",
  "item.minecraft.netherite_ingot": "Lingou de netherit",
  "item.minecraft.netherite_leggings": "Jambiere de netherit",
  "item.minecraft.netherite_nautilus_armor": "Armură de nautil din netherit",
  "item.minecraft.netherite_pickaxe": "Târnăcop de netherit",
  "item.minecraft.netherite_scrap": "Fragment de netherit",
  "item.minecraft.netherite_shovel": "Lopată de netherit",
  "item.minecraft.netherite_spear": "Suliță de netherit",
  "item.minecraft.netherite_sword": "Sabie de netherit",
  "item.minecraft.netherite_upgrade_smithing_template": "Șablon de fierărie",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Îmbunătățire cu netherit",
  "item.minecraft.oak_boat": "Barcă de stejar",
  "item.minecraft.oak_chest_boat": "Barcă de stejar cu cufăr",
  "item.minecraft.ocelot_spawn_egg": "Ou generator de ocelot",
  "item.minecraft.ominous_bottle": "Sticlă de rău augur",
  "item.minecraft.ominous_trial_key": "Cheie de încercări de rău augur",
  "item.minecraft.orange_bundle": "Săculeț portocaliu",
  "item.minecraft.orange_dye": "Colorant portocaliu",
  "item.minecraft.orange_harness": "Ham portocaliu",
  "item.minecraft.painting": "Pictură",
  "item.minecraft.pale_oak_boat": "Barcă de stejar palid",
  "item.minecraft.pale_oak_chest_boat": "Barcă de stejar palid cu cufăr",
  "item.minecraft.panda_spawn_egg": "Ou generator de panda",
  "item.minecraft.paper": "Hârtie",
  "item.minecraft.parched_spawn_egg": "Ou generator de uscat",
  "item.minecraft.parrot_spawn_egg": "Ou generator de papagal",
  "item.minecraft.phantom_membrane": "Membrană de fantasmă",
  "item.minecraft.phantom_spawn_egg": "Ou generator de fantasmă",
  "item.minecraft.pig_spawn_egg": "Ou generator de porc",
  "item.minecraft.piglin_banner_pattern": "Model pentru stindard",
  "item.minecraft.piglin_banner_pattern.desc": "Rât",
  "item.minecraft.piglin_banner_pattern.new": "Model pentru stindard de rât",
  "item.minecraft.piglin_brute_spawn_egg": "Ou generator de piglin brutal",
  "item.minecraft.piglin_spawn_egg": "Ou generator de piglin",
  "item.minecraft.pillager_spawn_egg": "Ou generator de jefuitor",
  "item.minecraft.pink_bundle": "Săculeț roz",
  "item.minecraft.pink_dye": "Colorant roz",
  "item.minecraft.pink_harness": "Ham roz",
  "item.minecraft.pitcher_plant": "Plantă-urcior",
  "item.minecraft.pitcher_pod": "Bulb de plantă-urcior",
  "item.minecraft.plenty_pottery_shard": "Ciob de ceramică de abundență",
  "item.minecraft.plenty_pottery_sherd": "Ciob de ceramică de abundență",
  "item.minecraft.poisonous_potato": "Cartof otrăvitor",
  "item.minecraft.polar_bear_spawn_egg": "Ou generator de urs polar",
  "item.minecraft.popped_chorus_fruit": "Fruct coral spart",
  "item.minecraft.porkchop": "Carne de porc crudă",
  "item.minecraft.potato": "Cartof",
  "item.minecraft.potion": "Poțiune",
  "item.minecraft.potion.effect.awkward": "Poțiune stingheră",
  "item.minecraft.potion.effect.empty": "Poțiune nefabricabilă",
  "item.minecraft.potion.effect.fire_resistance": "Poțiune de rezistență la foc",
  "item.minecraft.potion.effect.harming": "Poțiune de vătămare",
  "item.minecraft.potion.effect.healing": "Poțiune de vindecare",
  "item.minecraft.potion.effect.infested": "Poțiune de infestare",
  "item.minecraft.potion.effect.invisibility": "Poțiune de invizibilitate",
  "item.minecraft.potion.effect.leaping": "Poțiune de sărit",
  "item.minecraft.potion.effect.levitation": "Poțiune de levitație",
  "item.minecraft.potion.effect.luck": "Poțiune de noroc",
  "item.minecraft.potion.effect.mundane": "Poțiune banală",
  "item.minecraft.potion.effect.night_vision": "Poțiune de vedere nocturnă",
  "item.minecraft.potion.effect.oozing": "Poțiune de înmâzgare",
  "item.minecraft.potion.effect.poison": "Poțiune de otravă",
  "item.minecraft.potion.effect.regeneration": "Poțiune de regenerare",
  "item.minecraft.potion.effect.slow_falling": "Poțiune de cădere lentă",
  "item.minecraft.potion.effect.slowness": "Poțiune de încetineală",
  "item.minecraft.potion.effect.strength": "Poțiune de forță",
  "item.minecraft.potion.effect.swiftness": "Poțiune de viteză",
  "item.minecraft.potion.effect.thick": "Poțiune groasă",
  "item.minecraft.potion.effect.turtle_master": "Poțiune a maestrului țestoaselor",
  "item.minecraft.potion.effect.water": "Sticluță cu apă",
  "item.minecraft.potion.effect.water_breathing": "Poțiune de respirație subacvatică",
  "item.minecraft.potion.effect.weakness": "Poțiune de slăbiciune",
  "item.minecraft.potion.effect.weaving": "Poțiune de țesere",
  "item.minecraft.potion.effect.wind_charged": "Poțiune de încărcătura vântului",
  "item.minecraft.pottery_shard_archer": "Ciob de ceramică de arcaș",
  "item.minecraft.pottery_shard_arms_up": "Ciob de ceramică de figură",
  "item.minecraft.pottery_shard_prize": "Ciob de ceramică de premiu",
  "item.minecraft.pottery_shard_skull": "Ciob de ceramică de craniu",
  "item.minecraft.powder_snow_bucket": "Găleată cu zăpadă-pudră",
  "item.minecraft.prismarine_crystals": "Cristale de prismarin",
  "item.minecraft.prismarine_shard": "Ciob de prismarin",
  "item.minecraft.prize_pottery_shard": "Ciob de ceramică de premiu",
  "item.minecraft.prize_pottery_sherd": "Ciob de ceramică de premiu",
  "item.minecraft.pufferfish": "Pește-balon",
  "item.minecraft.pufferfish_bucket": "Găleată cu pește-balon",
  "item.minecraft.pufferfish_spawn_egg": "Ou generator de pește-balon",
  "item.minecraft.pumpkin_pie": "Plăcintă cu dovleac",
  "item.minecraft.pumpkin_seeds": "Semințe de dovleac",
  "item.minecraft.purple_bundle": "Săculeț violet",
  "item.minecraft.purple_dye": "Colorant violet",
  "item.minecraft.purple_harness": "Ham violet",
  "item.minecraft.quartz": "Cuarț de Nether",
  "item.minecraft.rabbit": "Iepure crud",
  "item.minecraft.rabbit_foot": "Labă de iepure",
  "item.minecraft.rabbit_hide": "Piele de iepure",
  "item.minecraft.rabbit_spawn_egg": "Ou generator de iepure",
  "item.minecraft.rabbit_stew": "Tocană de iepure",
  "item.minecraft.raiser_armor_trim_smithing_template": "Șablon de fierărie",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Ornament de armură de crescător",
  "item.minecraft.ravager_spawn_egg": "Ou generator de distrugător",
  "item.minecraft.raw_copper": "Cupru brut",
  "item.minecraft.raw_gold": "Aur brut",
  "item.minecraft.raw_iron": "Fier brut",
  "item.minecraft.recovery_compass": "Busolă de recuperare",
  "item.minecraft.red_bundle": "Săculeț roșu",
  "item.minecraft.red_dye": "Colorant roșu",
  "item.minecraft.red_harness": "Ham roșu",
  "item.minecraft.redstone": "Praf de redstone",
  "item.minecraft.resin_brick": "Cărămidă de rășină",
  "item.minecraft.resin_clump": "Bulgăre de rășină",
  "item.minecraft.rib_armor_trim_smithing_template": "Șablon de fierărie",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Ornament de armură de coaste",
  "item.minecraft.rotten_flesh": "Carne putrezită",
  "item.minecraft.saddle": "Șa",
  "item.minecraft.salmon": "Somon crud",
  "item.minecraft.salmon_bucket": "Găleată cu somon",
  "item.minecraft.salmon_spawn_egg": "Ou generator de somon",
  "item.minecraft.scrape_pottery_sherd": "Ciob de ceramică de răzuire",
  "item.minecraft.scute": "Solz",
  "item.minecraft.sentry_armor_trim_smithing_template": "Șablon de fierărie",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Ornament de armură de santinelă",
  "item.minecraft.shaper_armor_trim_smithing_template": "Șablon de fierărie",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Ornament de armură de modelator",
  "item.minecraft.sheaf_pottery_shard": "Ciob de ceramică de snop",
  "item.minecraft.sheaf_pottery_sherd": "Ciob de ceramică de snop",
  "item.minecraft.shears": "Foarfeci",
  "item.minecraft.sheep_spawn_egg": "Ou generator de oaie",
  "item.minecraft.shelter_pottery_shard": "Ciob de ceramică de adăpost",
  "item.minecraft.shelter_pottery_sherd": "Ciob de ceramică de adăpost",
  "item.minecraft.shield": "Scut",
  "item.minecraft.shield.black": "Scut negru",
  "item.minecraft.shield.blue": "Scut albastru",
  "item.minecraft.shield.brown": "Scut maro",
  "item.minecraft.shield.cyan": "Scut turcoaz",
  "item.minecraft.shield.gray": "Scut gri",
  "item.minecraft.shield.green": "Scut verde",
  "item.minecraft.shield.light_blue": "Scut bleu",
  "item.minecraft.shield.light_gray": "Scut gri-deschis",
  "item.minecraft.shield.lime": "Scut verde-deschis",
  "item.minecraft.shield.magenta": "Scut magenta",
  "item.minecraft.shield.orange": "Scut portocaliu",
  "item.minecraft.shield.pink": "Scut roz",
  "item.minecraft.shield.purple": "Scut violet",
  "item.minecraft.shield.red": "Scut roșu",
  "item.minecraft.shield.white": "Scut alb",
  "item.minecraft.shield.yellow": "Scut galben",
  "item.minecraft.shulker_shell": "Carapace de shulker",
  "item.minecraft.shulker_spawn_egg": "Ou generator de shulker",
  "item.minecraft.sign": "Semn",
  "item.minecraft.silence_armor_trim_smithing_template": "Șablon de fierărie",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Ornament de armură de tăcere",
  "item.minecraft.silverfish_spawn_egg": "Ou generator de peștișor argintiu",
  "item.minecraft.skeleton_horse_spawn_egg": "Ou generator de cal-schelet",
  "item.minecraft.skeleton_spawn_egg": "Ou generator de schelet",
  "item.minecraft.skull_banner_pattern": "Model pentru stindard",
  "item.minecraft.skull_banner_pattern.desc": "Cap de mort",
  "item.minecraft.skull_banner_pattern.new": "Model pentru stindard de cap de mort",
  "item.minecraft.skull_pottery_shard": "Ciob de ceramică de craniu",
  "item.minecraft.skull_pottery_sherd": "Ciob de ceramică de craniu",
  "item.minecraft.slime_ball": "Bulgăre de mâzgă",
  "item.minecraft.slime_spawn_egg": "Ou generator de mâzgă",
  "item.minecraft.smithing_template": "Șablon de fierărie",
  "item.minecraft.smithing_template.applies_to": "Se aplică la:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Adaugă lingou sau cristal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armură",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Adaugă o piesă de armură",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Lingouri și cristale",
  "item.minecraft.smithing_template.ingredients": "Ingrediente:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Adaugă un lingou de netherit",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Echipament de diamant",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Adaugă armura, arma sau unealta de diamant",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Lingou de netherit",
  "item.minecraft.smithing_template.upgrade": "Îmbunătățire: ",
  "item.minecraft.sniffer_spawn_egg": "Ou generator de adulmecător",
  "item.minecraft.snort_pottery_shard": "Ciob de ceramică de grohăială",
  "item.minecraft.snort_pottery_sherd": "Ciob de ceramică de grohăială",
  "item.minecraft.snout_armor_trim_smithing_template": "Șablon de fierărie",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Ornament de armură de rât",
  "item.minecraft.snow_golem_spawn_egg": "Ou generator de golem de zăpadă",
  "item.minecraft.snowball": "Bulgăre de zăpadă",
  "item.minecraft.spectral_arrow": "Săgeată spectrală",
  "item.minecraft.spider_eye": "Ochi de păianjen",
  "item.minecraft.spider_spawn_egg": "Ou generator de păianjen",
  "item.minecraft.spire_armor_trim_smithing_template": "Șablon de fierărie",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Ornament de armură de turlă",
  "item.minecraft.splash_potion": "Poțiune de aruncat",
  "item.minecraft.splash_potion.effect.awkward": "Poțiune stingheră de aruncat",
  "item.minecraft.splash_potion.effect.empty": "Poțiune de aruncat nefabricabilă",
  "item.minecraft.splash_potion.effect.fire_resistance": "Poțiune de rezistență la foc de aruncat",
  "item.minecraft.splash_potion.effect.harming": "Poțiune de vătămare de aruncat",
  "item.minecraft.splash_potion.effect.healing": "Poțiune de vindecare de aruncat",
  "item.minecraft.splash_potion.effect.infested": "Poțiune de infestare de aruncat",
  "item.minecraft.splash_potion.effect.invisibility": "Poțiune de invizibilitate de aruncat",
  "item.minecraft.splash_potion.effect.leaping": "Poțiune de sărit de aruncat",
  "item.minecraft.splash_potion.effect.levitation": "Poțiune de levitație de aruncat",
  "item.minecraft.splash_potion.effect.luck": "Poțiune de noroc de aruncat",
  "item.minecraft.splash_potion.effect.mundane": "Poțiune banală de aruncat",
  "item.minecraft.splash_potion.effect.night_vision": "Poțiune de vedere nocturnă de aruncat",
  "item.minecraft.splash_potion.effect.oozing": "Poțiune de înmâzgare de aruncat",
  "item.minecraft.splash_potion.effect.poison": "Poțiune de otravă de aruncat",
  "item.minecraft.splash_potion.effect.regeneration": "Poțiune de regenerare de aruncat",
  "item.minecraft.splash_potion.effect.slow_falling": "Poțiune de cădere lentă de aruncat",
  "item.minecraft.splash_potion.effect.slowness": "Poțiune de încetineală de aruncat",
  "item.minecraft.splash_potion.effect.strength": "Poțiune de forță de aruncat",
  "item.minecraft.splash_potion.effect.swiftness": "Poțiune de viteză de aruncat",
  "item.minecraft.splash_potion.effect.thick": "Poțiune groasă de aruncat",
  "item.minecraft.splash_potion.effect.turtle_master": "Poțiune a maestrului țestoaselor de aruncat",
  "item.minecraft.splash_potion.effect.water": "Sticluță cu apă de aruncat",
  "item.minecraft.splash_potion.effect.water_breathing": "Poțiune de respirație subacvatică de aruncat",
  "item.minecraft.splash_potion.effect.weakness": "Poțiune de slăbiciune de aruncat",
  "item.minecraft.splash_potion.effect.weaving": "Poțiune de țesere de aruncat",
  "item.minecraft.splash_potion.effect.wind_charged": "Poțiune de încărcătura vântului de aruncat",
  "item.minecraft.spruce_boat": "Barcă de molid",
  "item.minecraft.spruce_chest_boat": "Barca de molid cu cufăr",
  "item.minecraft.spyglass": "Ochean",
  "item.minecraft.squid_spawn_egg": "Ou generator de calamar",
  "item.minecraft.stick": "Băț",
  "item.minecraft.stone_axe": "Topor de piatră",
  "item.minecraft.stone_hoe": "Sapă de piatră",
  "item.minecraft.stone_pickaxe": "Târnăcop de piatră",
  "item.minecraft.stone_shovel": "Lopată de piatră",
  "item.minecraft.stone_spear": "Suliță de piatră",
  "item.minecraft.stone_sword": "Sabie de piatră",
  "item.minecraft.stray_spawn_egg": "Ou generator de hoinar",
  "item.minecraft.strider_spawn_egg": "Ou generator de umblător",
  "item.minecraft.string": "Ață",
  "item.minecraft.sugar": "Zahăr",
  "item.minecraft.suspicious_stew": "Supă suspectă",
  "item.minecraft.sweet_berries": "Fructe de pădure dulci",
  "item.minecraft.tadpole_bucket": "Găleată cu mormoloc",
  "item.minecraft.tadpole_spawn_egg": "Ou generator de mormoloc",
  "item.minecraft.tide_armor_trim_smithing_template": "Șablon de fierărie",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Ornament de armură de maree",
  "item.minecraft.tipped_arrow": "Săgeată impregnată",
  "item.minecraft.tipped_arrow.effect.awkward": "Săgeată impregnată",
  "item.minecraft.tipped_arrow.effect.empty": "Săgeată impregnată nefabricabilă",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Săgeată de rezistență",
  "item.minecraft.tipped_arrow.effect.harming": "Săgeată de vătămare",
  "item.minecraft.tipped_arrow.effect.healing": "Săgeată de vindecare",
  "item.minecraft.tipped_arrow.effect.infested": "Săgeată de infestare",
  "item.minecraft.tipped_arrow.effect.invisibility": "Săgeată de invizibilitate",
  "item.minecraft.tipped_arrow.effect.leaping": "Săgeată de sărit",
  "item.minecraft.tipped_arrow.effect.levitation": "Săgeată de levitație",
  "item.minecraft.tipped_arrow.effect.luck": "Săgeată de noroc",
  "item.minecraft.tipped_arrow.effect.mundane": "Săgeată impregnată",
  "item.minecraft.tipped_arrow.effect.night_vision": "Săgeată de vedere nocturnă",
  "item.minecraft.tipped_arrow.effect.oozing": "Săgeată de înmâzgare",
  "item.minecraft.tipped_arrow.effect.poison": "Săgeată de otravă",
  "item.minecraft.tipped_arrow.effect.regeneration": "Săgeată de regenerare",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Săgeată de cădere lentă",
  "item.minecraft.tipped_arrow.effect.slowness": "Săgeată de încetineală",
  "item.minecraft.tipped_arrow.effect.strength": "Săgeată de forță",
  "item.minecraft.tipped_arrow.effect.swiftness": "Săgeată de viteză",
  "item.minecraft.tipped_arrow.effect.thick": "Săgeată impregnată",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Săgeată a maestrului țestoaselor",
  "item.minecraft.tipped_arrow.effect.water": "Săgeată de stropire",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Săgeată de respirație subacvatică",
  "item.minecraft.tipped_arrow.effect.weakness": "Săgeată de slăbiciune",
  "item.minecraft.tipped_arrow.effect.weaving": "Săgeata țesăturii",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Săgeată cu încărcătura vântului",
  "item.minecraft.tnt_minecart": "Vagonet cu TNT",
  "item.minecraft.torchflower_seeds": "Semințe de floare torță",
  "item.minecraft.totem_of_undying": "Totem al nemuririi",
  "item.minecraft.trader_llama_spawn_egg": "Ou generator de lama negustorului",
  "item.minecraft.trial_key": "Cheie de încercare",
  "item.minecraft.trident": "Trident",
  "item.minecraft.tropical_fish": "Pește tropical",
  "item.minecraft.tropical_fish_bucket": "Găleată cu pește tropical",
  "item.minecraft.tropical_fish_spawn_egg": "Ou generator de pește tropical",
  "item.minecraft.turtle_helmet": "Carapace de țestoasă",
  "item.minecraft.turtle_scute": "Solz de țestoasă",
  "item.minecraft.turtle_spawn_egg": "Ou generator de țestoasă",
  "item.minecraft.vex_armor_trim_smithing_template": "Șablon de fierărie",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Ornament de armură de spirit",
  "item.minecraft.vex_spawn_egg": "Ou generator de spirit",
  "item.minecraft.villager_spawn_egg": "Ou generator de sătean",
  "item.minecraft.vindicator_spawn_egg": "Ou generator de apărător",
  "item.minecraft.wandering_trader_spawn_egg": "Ou generator de negustor ambulant",
  "item.minecraft.ward_armor_trim_smithing_template": "Șablon de fierărie",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ornament de armură de pază",
  "item.minecraft.warden_spawn_egg": "Ou generator de gardian",
  "item.minecraft.warped_fungus_on_a_stick": "Ciupercă deformată pe un băț",
  "item.minecraft.water_bucket": "Găleată cu apă",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Șablon de fierărie",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Ornament de armură de călăuză",
  "item.minecraft.wheat": "Grâu",
  "item.minecraft.wheat_seeds": "Semințe de grâu",
  "item.minecraft.white_bundle": "Săculeț alb",
  "item.minecraft.white_dye": "Colorant alb",
  "item.minecraft.white_harness": "Ham alb",
  "item.minecraft.wild_armor_trim_smithing_template": "Șablon de fierărie",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Ornament de armură de sălbăticie",
  "item.minecraft.wind_charge": "Minge de vânt",
  "item.minecraft.witch_spawn_egg": "Ou generator de vrăjitoare",
  "item.minecraft.wither_skeleton_spawn_egg": "Ou generator de schelet wither",
  "item.minecraft.wither_spawn_egg": "Ou generator de wither",
  "item.minecraft.wolf_armor": "Armură de lup",
  "item.minecraft.wolf_spawn_egg": "Ou generator de lup",
  "item.minecraft.wooden_axe": "Topor de lemn",
  "item.minecraft.wooden_hoe": "Sapă de lemn",
  "item.minecraft.wooden_pickaxe": "Târnăcop de lemn",
  "item.minecraft.wooden_shovel": "Lopată de lemn",
  "item.minecraft.wooden_spear": "Suliță de lemn",
  "item.minecraft.wooden_sword": "Sabie de lemn",
  "item.minecraft.writable_book": "Carte și condei",
  "item.minecraft.written_book": "Carte scrisă",
  "item.minecraft.yellow_bundle": "Săculeț galben",
  "item.minecraft.yellow_dye": "Colorant galben",
  "item.minecraft.yellow_harness": "Ham galben",
  "item.minecraft.zoglin_spawn_egg": "Ou generator de zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Ou generator de cal-zombi",
  "item.minecraft.zombie_nautilus_spawn_egg": "Ou generator de nautil-zombi",
  "item.minecraft.zombie_spawn_egg": "Ou generator de zombi",
  "item.minecraft.zombie_villager_spawn_egg": "Ou generator de sătean-zombi",
  "item.minecraft.zombified_piglin_spawn_egg": "Ou generator de piglin zombificat"
}
export const ro_ro = items; 
